<template>
    <div :id="store.state.isH5 ? 'allstyle' : ''">
        <div v-show="data.loading">
            <nut-overlay v-model:visible="data.loading" :lock-scroll="true">
                <div class="wrapper">
                    <nut-icon name="loading" size="32px"></nut-icon>
                </div>
            </nut-overlay>
        </div>
        <!-- {{ JSON.stringify(route.query) }} -->
        <div>
            <div v-if="!data.isH5">
                <view315TitleVue :show-exam-btn="false" :title="data.vue315Title" @backEvent="backEvent"></view315TitleVue>
            </div>
            <div v-if="data.isAuditNoPass" class="auditNoPass">
                <img src="../../assets/image_message_appear/good.png" alt />
                <div>
                    <span>{{ route.params.checkResult === '{}' || route.params.checkResult == "" ? 
                    '不合格原因' : '已采纳' }}</span>
                    <span>｜{{ data.checkDescription }}</span></div>
            </div>
            <div class="box" style="padding:0 20px;">
                <!-- 新增 -->
                <div class="typeSelectBox" v-if="!data.isInternalUser">
                    <div class="detail_title" style="font-size: 18px;">本次参与类型选择</div>
                    <div class="typeSelect mgTp5">
                        <div v-for="item in data.addLocationTypeSelect" :class="[item.className]" :key="item.value"
                            @click="locationTypeSelect(item.value)">
                                <button
                                style="margin-top: 14px"
                                :class="['locationDownLineSpanActive', item.select ? 'activeBtn':'defaultBtn']"
                                >{{ item.label }}</button>
                        </div>
                    </div>
                </div>
                <!-- 共有 -->
                <div class="pdTp14 borderBM1">
                    <div class="detail_title">1.地点名称<span class="redPoint"></span></div>
                    <div class="mgTp5">
                        <div @click="locationNameGet" :class="['locationGet',
                            data.formData.locationName == '' ? 'locationGetHui' : '']">
                            {{ data.formData.locationName == '' ?
                                '请输入店招完整名称' :
                                data.formData.locationName }}
                        </div>
                    </div>
                    <!-- <div class="mgTp5" v-if="data.isH5">
                        <input
                            id="newAdd"
                            type="text"
                            @change="getUserLocationInfo2({lng: store.state.location.split(',')[1], lat: store.state.location.split(',')[0],type: 'map'})"
                            class="wayInfo_input"
                            v-model="data.formData.locationName"
                            placeholder="请输入店招完整名称"
                            maxlength="144"
                            />
                    </div> -->
                </div>
                <!-- 改要素 新增 地图 -->
                <div v-if="data.mapTitle" :class="data.isH5 ? 'MGTP24' : 'MGTP28'">
                    <div v-if="data.pageType == '1'" class="detail_title">
                        <span>
                            2.{{ data.mapTitle }}<span class="redPoint"></span>
                        </span>
                    </div>
                    <div v-if="data.pageType == '3'" class="fix_information">
                        <div class="detail_title mgBm10 ">
                            2.选择需要修改的信息（可选填）
                        </div>
                        <div id="map" class="mgTp10" :style="{ position: (data.formData.locationName == '' ? 'absolute' : 'relative'),visibility: (data.formData.locationName == '' ?  'hidden' : 'visible') }"></div>
                        <!-- 地名详情 -->
                        <div style="margin-bottom: 15px;">
                            <div v-for="item in data.mapInfo" :key="item.name" :class="[item.title ? '' : 'fontWNor mapInfoLi', 'detail_title', 'mgTp5',
                                'mapInfoUl', 'mgBm5']">
                                <span>{{ item.name }}</span>
                            </div>
                        </div>
                        <span class="detail_title fontWNor">
                            {{ data.mapTitle }}
                        </span>
                    </div>
                    <!-- 戳点时展示 -->
                    <div @click="PicLoction" style="margin-top: 12px;">
                        <!-- <div class="mapBanner" v-if="data.isH5 && data.showlor"> -->
                        <!-- <div class="mapBanner"> -->
                            <!-- <iframe
                                id="myMap"
                                width="100%"
                                height="400px"
                                frameborder=0
                                :src="data.href"
                                >
                            </iframe> -->
                        <!-- </div> -->
                        <div class="mapBanner" v-if="!data.userCheckDetail">
                            <img v-if="!data.userSelectPoint" :src="data.mapImg" alt />
                            <img v-else :src="data.mapImgSelected" alt />
                        </div>
                        <div class="mapBanner" v-else>
                            <img :src="data.mapImgCheck" alt />
                        </div>
                        <div class="map_location">地图位置</div>
                    </div>
                    <!-- 戳点完成后展示 -->
                    <div v-if="data.userSelectPoint">
                        <div class="detail_title fontWNor mgTp10">
                            地点地址
                            <span v-if="data.isAuditNoPass && !data.checkContent.coordinate" class="auditNoPass_more auditNoPass_ab">
                                <span>不合格原因｜{{ data.checkContentResult.coordinate }}</span>
                            </span>
                        </div>
                        <div style="border-bottom: 1px solid rgba(0,0,0, 0.1);">
                            <div :class="['detail_title', 'fontWNor', 'mgTp10', 
                            data.formData.userSelectDetailLocation == '' && data.userCheckDetail ?'spanReplaceInputShowData' : '']">{{ data.formData.userSelectLocationName }}</div>
                            <input type="text" class="inputSet" v-if="!data.userCheckDetail" style="padding:10px 0px 10px;"
                                v-model="data.formData.userSelectDetailLocation"   maxlength="50"
                                placeholder="输入更详细地址，精确到门牌号或某店铺旁边"  @focus="e => businessPhoneFocus(0, e)"/>
                            <div class="divReplaceInputShowData spanReplaceInputShowData" v-if="data.userCheckDetail && data.formData.userSelectDetailLocation != ''">{{ data.formData.userSelectDetailLocation }}</div>
                            
                        </div>
                    </div>
                </div>
                <!-- 过期验证 过期原因 -->
                <div v-if="data.pageType == '2'" :class="data.isH5 ? 'MGTP24' : 'MGTP28'">
                    <div class="detail_title">2.地点下线原因<span class="redPoint"></span></div>
                    <div class="locationDownLineDiv">
                        <span v-for="(item, index) in data.locationDownLine" :key="item.value"
                            @click="locationPassReasonBtn(item.value, index)"
                            :class="['locationDownLineSpanActive', 'locationDownLine', !item.select ? 'defaultBtn':'activeBtn']">{{ item.label }}</span>
                    </div>
                </div>
                <div id="business" v-if="data.pageType != '2'" :class="data.isH5 ? 'MGTP24' : 'MGTP28'">
                    <!-- 改要素 经营信息 -->
                    <div class="detail_title" v-if="data.showMoreTitle && data.pageType == '1'">5.更多信息（非必填，可补充）</div>
                    <div class="detail_title fontWNor mgTp10 businessPhone borderBM1" v-if="(!data.userCheckDetail && data.pageType == '3')
                    || (data.userCheckDetail && data.pageType == '3' && data.formData.locationNewName != '')">
                        <div class="in_block_span">
                            请输入新店铺名称
                            <span v-if="data.isAuditNoPass && !data.checkContent.locationName" class="auditNoPass_more auditNoPass_ab" style="margin-left: 3%;">
                                <span>不合格原因｜{{ data.checkContentResult.locationName }}</span>
                            </span>
                        </div>
                        <span 
                        v-if="!data.userCheckDetail" class="businessPhone_span_box">
                            <input class="inputSet date_picker_select_time_over" type="text" style="padding-left: 0;" 
                            @focus="e => businessPhoneFocus(1, e)" maxlength="30" @blur="e => tDelIconClick('locationNewName', e)"
                                v-model="data.formData.locationNewName" placeholder="请输入" />
                            <t-icon v-if="data.formData.locationNewName != '' && data.showLocationNewNameIcon" name="close-circle-filled" size="16px" style="opacity: 0.5;" @click="data.formData.locationNewName = ''"/>
                        </span>
                        <span v-else class="spanReplaceInputShowData">{{ data.formData.locationNewName }}</span>
                    </div>
                    <div style="position: relative;" v-if="!data.userCheckDetail || 
                    (data.userCheckDetail && data.formData.businessTime.length > 0 
                    && data.formData.businessTime[0].start != '')">
                        <span class="businessTime_title">
                            请选择营业时段
                            <span v-if="data.isAuditNoPass && !data.checkContent.businessTime && data.formData.businessTime.length > 0 
                            && data.formData.businessTime[0].start != ''" class="auditNoPass_more auditNoPass_ab">
                                <span>不合格原因｜{{ data.checkContentResult.businessTime }}</span>
                            </span>
                        </span>
                        <div class="detail_title fontWNor mgTp6 borderBM1" style="position: relative;"
                            v-for="(item, index) in data.formData.businessTime" :key="index">
                            <span v-if="data.formData.businessTime.length > 0 && !data.userCheckDetail">
                                <span style="opacity: 1;" class="in_block_span business_time_picker"
                                 @click="deleBusiness(index, 'time')">
                                    <img class="business_icon" style="margin-right: 8px;" :src="data.businessTimeDel">
                                    <span class="business_span business_picker">营业时段{{ index + 1 }}</span>
                                </span>
                            </span>
                            <span v-if="data.formData.businessTime.length > 0 && data.userCheckDetail">
                                <span style="opacity: 1;" class="in_block_span business_time_picker">
                                    <span class="business_span business_picker">营业时段{{ index + 1 }}</span>
                                </span>
                            </span>
                            <span v-if="data.userCheckDetail" class="date_picker_select_time date_picker_select_time_over new_date_picker_select_time">{{ item.start }}</span>
                            <span v-if="!data.userCheckDetail" @click="showSelectTimePopup('start', index)" 
                            :class="['date_picker_select_time', item.start == '请选择' ? '' : 'date_picker_select_time_over', 'new_date_picker_select_time']">{{ item.start }}</span>
                            <t-icon name="chevron-right" size="20px" style="color: #17181A;opacity: 0.3;" />
                            <span class="date_picker_select_time_mark">至</span>
                            <span v-if="data.userCheckDetail" class="date_picker_select_time date_picker_select_time_over new_date_picker_select_time">{{ item.end }}</span>
                            <span v-if="!data.userCheckDetail"   @click="showSelectTimePopup('end', index)"
                            :class="['date_picker_select_time', item.end == '请选择' ? '' : 'date_picker_select_time_over', 'new_date_picker_select_time']">{{ item.end }}</span>
                            <t-icon name="chevron-right" size="20px" style="color: #17181A;opacity: 0.3;" />
                        </div>
                        <span :class="['in_block_span', 'business_MB_TP_20']" :style="{ marginTop: data.formData.businessTime.length > 0 ? '16px' : '20px' }"
                            v-if="!data.userCheckDetail" @click="addFormDataBusiness('time')">
                            <img class="business_icon" :src="data.businessTimeAdd">
                            <span class="business_span" v-if="data.formData.businessTime.length > 0">添加其他营业时段</span>
                            <span class="business_span" v-if="data.formData.businessTime.length == 0">添加营业时段</span>
                        </span>
                    </div>
                    <div class="businessDate" v-if="!data.userCheckDetail || (data.userCheckDetail && 
                    data.formData.businessDate != '')">
                        <div class="detail_title fontWNor MGTP28 borderBM1">
                            <div class="in_block_span">
                                请选择营业日期
                                <span v-if="data.isAuditNoPass && !data.checkContent.businessDate && 
                                    data.formData.businessDate != ''" class="auditNoPass_more auditNoPass_ab">
                                    <span>不合格原因｜{{ data.checkContentResult.businessDate }}</span>
                                </span>
                            </div>
                            <span class="businessDate_span_box">
                                <span v-if="!data.userCheckDetail" @click="showBusinessDatePopup" :class="['date_picker_select_time', 'select', data.formData.businessDate != '请选择' ? 'date_picker_select_time_over' : '']">{{
                                data.formData.businessDate }}</span>
                                <span v-else class="date_picker_select_time date_picker_select_time_over select">{{ data.formData.businessDate }}</span>
                                <!-- <t-icon v-if="data.formData.businessDate != '请选择'"  style="opacity: 0.5;"
                                name="close-circle-filled" size="16px" @click="e => resetBusinessPhone('businessTimePic', e)"/> -->
                                <t-icon name="chevron-right" size="20px" style="color: #17181A;opacity: 0.3;" />
                            </span>
                        </div>
                    </div>
                    <div class="advise_photo_info mgTp20" v-if="(!data.userCheckDetail && data.formData.businessTime.length > 0) || (!data.userCheckDetail && data.formData.businessDate != '请选择') || 
                    (data.userCheckDetail && data.formData.businessTimePic.length > 0)">
                    请拍摄营业时间相关的照片，如宣传图、广告牌等</div>
                    <photoVue v-if="(!data.userCheckDetail && data.formData.businessTime.length > 0) || 
                    (!data.userCheckDetail && data.formData.businessDate != '请选择') || (data.userCheckDetail && 
                    data.formData.businessTimePic.length > 0)" listType="businessTimePic" :list="data.formData.businessTimePic" @previewImg="photoPreviewImg" :number="10"
                        @selectPicType="photoSelectPicType" @deletePic="photoDeletePic" type="photo" :latlng="data.photoLatLng"
                        @photoadd="photoaddwx"
                        :userCheckDetail="data.userCheckDetail" :userLocation="data.userLocation" :pageType="data.pageType"/>
                    <!-- 营业电话 -->
                    
                    <div style="position: relative;" v-if="!data.userCheckDetail || (data.userCheckDetail && 
                    data.formData.businessPhone != '')" class="businessPhone borderBM1">
                        <div class="detail_title fontWNor mgTp10" style="position: relative;">
                            <div class="in_block_span MGTP28">
                                请输入营业电话
                                <span v-if="data.isAuditNoPass && !data.checkContent.businessPhone && 
                                data.formData.businessPhone != ''" class="auditNoPass_more auditNoPass_ab">
                                    <span>不合格原因｜{{ data.checkContentResult.businessPhone }}</span>
                                </span>
                            </div>
                            <span v-if="!data.userCheckDetail" class="businessPhone_span_box">
                                <input class="inputSet date_picker_select_time_over"
                                    style="padding-left: 0;" placeholder="请输入" v-model="data.formData.businessPhone" @blur="e => tDelIconClick('businessPhone', e)"
                                    type="text"  maxlength="30" @focus="e => businessPhoneFocus(2, e)"/>
                                <t-icon v-if="data.formData.businessPhone != '' && data.showBusinessPhoneIcon" name="close-circle-filled" size="16px" style="opacity: 0.5;" @click="e => resetBusinessPhone('businessPhonePic', e)"/>
                            </span>
                            <span v-else class="spanReplaceInputShowData">{{ data.formData.businessPhone }}</span>
                        </div>
                    </div>
                    <div class="advise_photo_info mgTp20" v-if="(!data.userCheckDetail && data.formData.businessPhone != '') || (data.userCheckDetail && 
                    data.formData.businessPhonePic.length > 0)">请拍摄营业电话相关的照片，如宣传图、广告牌等</div>
                    <photoVue v-if="(!data.userCheckDetail && data.formData.businessPhone != '') || (data.userCheckDetail && 
                    data.formData.businessPhonePic.length > 0)" :list="data.formData.businessPhonePic" @deletePic="photoDeletePic" :number="10"
                        @selectPicType="photoSelectPicType" @photoadd="photoaddwx" @previewImg="photoPreviewImg" type="photo" listType="businessPhonePic"
                        :userCheckDetail="data.userCheckDetail"  :latlng="data.photoLatLng" :userLocation="data.userLocation"
                        ide="asdasd"
                        :pageType="data.pageType"/>
                </div>
                <div id="location">
                    <!-- 现场图片 -->
                    <div>
                        <div :class="data.isH5 ? 'detail_title MGTP24' : 'detail_title MGTP28'">3.现场图片<span class="redPoint"></span></div>
                        <div class="advise_photo_info">请拍摄地点的门脸和左右两侧的商铺或建筑</div>
                        <photoVue :list="data.formData.locationPics" @deletePic="photoDeletePic" :number="10"
                            @selectPicType="photoSelectPicType" @previewImg="photoPreviewImg" type="photo"  listType="locationPics"
                            @photoadd="photoaddwx" :userCheckDetail="data.userCheckDetail"  :latlng="data.photoLatLng" :userLocation="data.userLocation"
                            ide="asdasrrrd"
                            :pageType="data.pageType"/>
                    </div>
                    <!-- 现场视频 -->
                    <div :class="data.isH5 ? 'MGTP24' : 'MGTP28'">
                        <div class="detail_title">4.现场视频<span class="redPoint"></span></div>
                        <div class="advise_photo_info">请拍摄地点周围环境的视频</div>
                        <photoVue :list="data.formData.locationVideo" @deletePic="photoDeletePic" :number="5"
                            @selectPicType="photoSelectPicType" @previewImg="photoPreviewImg" ref="LocationVideo" type="video"
                            @photoadd="photoaddwx" :userCheckDetail="data.userCheckDetail"   listType="locationVideo" :latlng="data.photoLatLng"
                            :userLocation="data.userLocation" :pageType="data.pageType"/>
                    </div>
                </div>
                <!-- 补充信息 -->
                <div v-if="!data.userCheckDetail || (data.userCheckDetail && 
                    data.formData.userComment != '')">
                    <div class="detail_title remark">备注</div>
                    <div v-if="!data.userCheckDetail" :class="['goOnInfo', data.showAddTemplateText ? 'add_template' : '']">
                        <textarea :class="['textarea_public', data.showAddTemplateText ? 'textarea_info' : '']" maxlength="100"
                        v-model="data.formData.userComment"
                        placeholder="其他需要说明的信息，或者个人联系方式，方便工作人员后续进一步跟您核实">
                        </textarea>
                        <div class="add_template_text" v-show="data.showAddTemplateText">
                            <div @click="addTemplateEvent(0)">点击此处加油站上报模版一键填写</div>
                            <div @click="addTemplateEvent(1)">点击此处充电站上报模版一键填写</div>
                        </div>
                    </div>
                    <div class="goOnInfo" v-else>{{ data.formData.userComment }}</div>
                </div>
                <div v-else style="height: 150px;"></div>
            </div>
            <div :class="['appeared', data.isShowFillInBtn ? 'showFillinBtn' : 'hiddenFillinBtn']">
                <button v-if="!data.userCheckDetail" @click="FillInEvent"
                    :class="[data.userFillInComplete ? 'complete ' : '']">完成上报</button>
                <button v-else @click="backEvent" :class="data.userFillInComplete ? 'complete ' : ''">返回</button>
            </div>
        </div>
        <div class="dialogObscuration" v-if="$store.state.messageAppearDetailVisble">
            <div class="dialogImg">
                <span @click="dialogCancle"></span>
                <span @click="dialogOk"></span>
            </div>
        </div>
        <!-- 营业时间 -->
        <t-popup v-model="useSelectTimePopup" placement="bottom">
            <t-date-time-picker
                v-model="data.formData.userSelectTime"
                :class="store.state.isH5 ?  data.isiOS ? 't_date_time_picker_self newcss' : 't_date_time_picker_self newcss5' : 't_date_time_picker_self'"
                default-value="10:10"
                :mode="[null, 'minute']"
                title="选择营业时间"
                format="HH:mm"
                @confirm="businessTimeconfirm"
                @cancel="businessTimeCancel"
                style="font-size: 16px;padding-top: 15px;"
                />
        </t-popup>
        <!-- <nut-datepicker v-model="data.formData.userSelectTime" v-model:visible="useSelectTimePopup" title="时间选择" type="time"
            @confirm="businessTimeconfirm"></nut-datepicker> -->
        <!-- 营业日期 -->
        <!-- <nut-actionsheet v-model:visible="selectBusinessDatePopup" title="日期选择">
            <div class="sheet_pick_date">
                <div class="sheet_box">
                    <div v-for="item in data.columns" :class="['cloums_week']" :key="item.value">
                        <nut-checkbox @change="businessDateConfirm" v-model="item.select" :label="item.text">{{ item.text }}</nut-checkbox>
                    </div>
                </div>
            </div>
        </nut-actionsheet> -->
        <t-popup v-model="selectBusinessDatePopup" placement="bottom" :closeOnOverlayClick="false">
            <div>
                <div class="businessData_popup_header">
                    <div class="businessData_popup_btn businessData_popup_btn--cancel" aria-role="button" @click="businessDateCancel">取消</div>
                    <div class="businessData_popup_title">选择营业日期</div>
                    <div class="businessData_popup_btn businessData_popup_btn--confirm" aria-role="button" @click="businessDateConfirm">确定</div>
                </div>
                <div class="businessData_popup_cloums_week">
                    <t-checkbox-group v-model:value="data.businessDateArr" class="horizontal-box">
                        <div v-for="item in data.columns.map(item => item.text)" :key="item" :class="`card ${data.businessDateArr.indexOf(item) > -1 ? 'card--active' : data.businessDateArr.indexOf(item)}`">
                        <t-icon v-if="data.businessDateArr.indexOf(item) > -1" name="check" class="card__icon" :aria-hidden="true" />
                        <t-checkbox :value="item" :label="item" icon="none" borderless/>
                        </div>
                    </t-checkbox-group>
                </div>
            </div>
        </t-popup>
        <!-- 查看图片 -->
        <previewImage v-if="data.showPreviewImg" :showPreviewVideo="data.showPreviewVideo" :source="data.sourceVideo"
            :showPreviewImg="data.showPreviewImg" :photoList="data.previewImageList" :initPage="data.initPage"
            :isViewExample="data.isViewExample" @setShowPreviewVideo="getShowPreviewVideo"
            @setShowPreviewImg="getShowPreviewImg">
        </previewImage>

        <!-- 不在运营范围内 -->
        <nut-overlay v-model:visible="data.notAllowReport" :lock-scroll="true" :close-on-click-overlay="false">
            <div class="wrapper">
                <div class="content">{{ data.notAllowReportText }}</div>
            </div>
        </nut-overlay>
        <!-- 确定清楚营业时间或营业电话 -->
        <nut-popup v-model:visible="showBusinessDelPopup" style="width: 82%;margin: 0 auto;border-radius: 8px;padding: 8% 5% 5%;">
            <div class="business_del_box">
                <div class="business_del_info">确认清除？清除{{ businessDelButtonType == 'businessPhonePic' ? '电话' : '日期' }}后已拍摄的照片会同步删除。</div>
                <div class="business_info_btn">
                    <div @click="showBusinessDelPopup = false" class="cancel">取消</div>
                    <div @click="resetBusinessInfo" class="confirm">清空</div>
                </div>
            </div>
        </nut-popup>
        <nut-overlay v-model:visible="data.locshow" z-index="1000" :lock-scroll="true" :close-on-click-overlay="false" @click="data.locshow = false">
                <div class="wrapper_overlay" @click="data.locshow = false">
                    <div class="content">{{ '请点击继续操作' }}</div>
                </div>
        </nut-overlay>
    </div>
</template>
<script  setup>
import {
    onMounted,
    reactive,
    ref,
    onBeforeMount,
    watch,
    getCurrentInstance,
    nextTick,
} from "vue";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import { Notify, Toast } from "@nutui/nutui";
import { useStore } from 'vuex'
import md5 from 'js-md5';
import { jsonp } from 'vue-jsonp'
import utils from '../../utils/utils'
import view315TitleVue from "../../components/view315Title.vue";
import previewImage from "../../components/previewImage";
import photoVue from "../../components/photo.vue";
// import resroute from '../../router/restroute';
import request from '@/utils/request';
import {
    // addLocationTypeSelect,
    mapImgCheck,
    mapImgSelected,
    mapImg,
    columns,
    locationDownLine,
    businessTimeAndPhonePic,
    locationPics,
    locationVideo, 
    newAddLocationList,
    businessTimeAdd,
    businessTimeDel,
    radioSelect,
} from "../config";
import cosPutObject from '../cosPutObject.js'
// import cosGetObjectUrl from '../cosGetObjectUrl'
import { citys } from '../city';
import wx from 'weixin-js-sdk';
import { classifyLists } from '../classify'
import * as api from '../../utils/api'
import * as api2 from '../../utils/apiIntegral'
import {
    toYYMMDDHMS,
    // isPlatformPC
} from '../../utils/utils'
const Cos = require("cos-js-sdk-v5");
const easyearn = window.easyearn
const TMap = window.TMap
const {
    proxy: { $forceUpdate }
} = getCurrentInstance()
// webserviceApi接口 https://lbs.qq.com/service/webService/webServiceGuide/webServiceOverview
const webServerApiGetInfo = 'https://apis.map.qq.com/ws/geocoder/v1'
const webServerApiGetInfo2 = 'https://apis.map.qq.com/ws/place/v1/search' // 道路名解析
// const webServerApiGetBusinessTime = 'https://apis.map.qq.com' // 时间接口
// webservice API
// const key = 'JIOBZ-X43O4-SNVU7-D45ZU-F3LMS-K5BQT'
const key = '4D3BZ-MN5H6-DP2SB-M4C6B-R4EDK-JXB2Q'
const sk = 'THD7tcTnFmTnjYiVqCjYgmArpf75QXQ'
// 映射
const formDataPicAndVideoTransf = new Map([
    ['businessTimePic', '营业时间照'],
    ['locationPics', '门脸照'],
    ['locationVideo', '拍视频'],
    ['businessPhonePic', '营业电话照'],
])

const route = useRoute()
const router = useRouter()

const store = useStore()

// 获取拍摄视频的dom ref
const LocationVideo = ref(null)
// 展示删除营业日期和营业电话的图片
const showBusinessDelPopup = ref(false)
// 选择时间弹框
const useSelectTimePopup = ref(false)
// 选择营业日期展示
const selectBusinessDatePopup = ref(false)
// 删除按钮类型
const businessDelButtonType = ref(null)
// 当前点击的是开始时间还是结束时间
const useSelectTimeType = ref(null)
const photoaddwx = (res) => {
    data.controlpictoweixin = true;
    data.judge = res[0].url.indexOf('ishare-10003415')
    const formDataValue = data.formData[data.userClickPic]
    const srcNullIndex = formDataValue.findIndex(item => item.src === '')
    if (srcNullIndex >= 0) {
        formDataValue.splice(srcNullIndex, 1)
    }
    data.photonum = res.length;
    res.map((resItem, resIndex) => {
        let obj = {
            index: formDataValue.length + resIndex,
            src: resItem.url.indexOf('http') > -1 ? resItem.url : `http://${resItem.url}`,
            srcCopy: resItem.url.indexOf('http') > -1 ? resItem.url : `http://${resItem.url}`,
            title: formDataValue.length == 0 ?  
            formDataPicAndVideoTransf.get(data.userClickPic) : '补充照',
            lat: resItem.lat,
            lng: resItem.lng,
            angle: resItem.angle,
            time: resItem.time,
            text: '',
            type: data.userClickPic,
        }
        formDataValue.push(obj)
        setTimeout(() => {
            recivePicPathGetUrl(resItem.url, srcNullIndex + resIndex, data.userClickPic);
        }, 50);
    })
    if (formDataValue.length < 10) {
        let obj = {
            index: formDataValue.length + 1,
            src: '',
            srcCopy: '',
            title: formDataValue.length == 1 ?  
            formDataPicAndVideoTransf.get(data.userClickPic) : '补充照',
            lat: '',
            lng: '',
            angle: '',
            time: '',
            text: '',
            type: data.userClickPic,
        }
        formDataValue.push(obj)
    }
}
const data = reactive({
    controlpictoweixin: false,
    photonum: '',
    timestamp: '', // 时间戳
    isiOS: null,
    locshow: false,
    scrollTop: 0,
    title:'地点', // 为了通过判断
    addLocationTypeSelect: [],
    locationTypeSelectClick: false,
    mapImgCheck,
    mapImg,
    mapImgSelected,
    locationDownLine,
    businessTimeAndPhonePic,
    locationPics,
    locationVideo, 
    columns,
    newAddLocationList,
    businessTimeAdd,
    businessTimeDel,
    map: null,
    marker: null,
    vue315Title: '地点新增',
    notAllowReport: false, // 是否在运营范围内
    notAllowReportText: '',
    loading: true,// 是否需要展示遮罩层
    pageType: null, // 1 地点新增 2 地点不存在 3 地点信息更改
    mapTitle: '', // 地图标题
    userCheckDetail: false, // 用户查看
    userSelectPoint: false, // 用户是否戳点
    latlng: '', // 纬度 经度
    userFillInComplete: false, // 用户是否填写完成
    firstSubmitEvent: true, // 是否是第一次提交 
    showPreviewImg: false, // 是否展示浏览
    showPreviewVideo: false, // 是否展示视频
    isShowFillInBtn: true, // 是否展示完成上报按钮
    isAuditNoPass: false, // 是否审核未通过
    showlor: false, // 是否展示地图(小)
    checkDescription: '', // 不合格原因
    // 各要素不合格原因
    checkContentResult: {
        businessPhone: '',
        businessTime: '',
        businessDate: '',
        locationName: '', // 店铺新名称
        coordinate: '', // 店铺新名称
    },
    // 各要素是否合格
    checkContent: {
        businessPhone: true,
        businessTime: true,
        businessDate: true,
        locationName: true,
        coordinate: true,
    },
    sourceVideo: {}, // 视频
    isViewExample: false, // 浏览图片时是否是示例
    previewImageList: [],// 展示图片列表
    initPage: 0, // 预览当前页
    userClickPic: null, // 用户点击的图片
    userClickCurrent: null, // 用户点击的下标
    userLevel: '', // 用户当前等级
    // 地图详情
    mapInfo: [],
    locationPid: '', // 地点唯一标识
    cityArrayFlat: [], // 地点数组打散
    // 是否允许退出
    isAllowExit: false,
    // 新增地点名称删除icon是否展示
    showLocationNewNameIcon: false,
    // 营业手机号删除icon是否展示
    showBusinessPhoneIcon: false,
    classifyFlat: [], // 上报分类打散
    userLocationADCode: '', // 全国-省-市-区
    showMoreTitle: true, // 在查看新增时是否展示更多信息标题
    photoLatLng: '', // 图片展示需要的坐标
    userLocation: {}, // 拍摄图片和视频时用
    businessDateArr: [], // 用户选择的营业日期
    // form表单数据
    formData: {
        locationName: '', // 名称
        locationNewName: '', // 新的店名
        userLatLng: '', // 用户戳点坐标
        userSelectTime: '', // 从date-picker组件中获取的时间
        businessDate: '请选择', // 营业日期
        // 展示在页面上的营业时间
        businessTime: [],
        // 如果图片的title修改对应recivePicPathGetUrl方法也要修改
        // 营业图片
        businessTimePic: [
            {
                index: 1,
                type: 'businessTimePic',
                src: '',
                srcCopy: '',
                title: '营业时间照',
                lat: '',
                lng: '',
                angle: '',
                time: '',
                text: '',
            }
        ],
        // 现场图片
        locationPics: [
            {
                index: 1,
                src: '',
                type: 'locationPics',
                srcCopy: '',
                title: "门脸照",
                lat: '',
                lng: '',
                angle: '',
                time: '',
                text: '',
            }
        ],
        // 现场视频
        locationVideo: [
            {
                index: 1,
                src: '',
                type: 'locationVideo',
                srcCopy: '',
                title: '拍视频',
                lat: '',
                lng: '',
                tracks: [],
                angle: '',
                time: '',
                text: '',
                poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
            }
        ],
        // 营业电话图片
        businessPhonePic: [
            {
                index: 1,
                src: '',
                type: 'businessPhonePic',
                srcCopy: '',
                title: '营业电话照',
                lat: '',
                lng: '',
                angle: '',
                time: '',
                text: '',
            }
        ],
        // 营业电话
        businessPhone: '',
        userComment: '', // 用户补充
        locationPassReason: '', // 地点过期原因
        userSelectLocationName: '', // 用户戳点中文位置
        userSelectDetailLocation: '', // 用户戳点后输入详细地址
    },
    isInternalUser: false, // 是否是内部用户
    isH5: false, // 是否是内部用户
    datayime: true, // 是否是内部用户
    href: `https://apis.map.qq.com/tools/locpicker?search=1&total=0&type=1&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅汇图&coord=${store.state.location}`,
    showAddTemplateText: false, // 是否展示一键添加文案
})

const cos = new Cos({
    getAuthorization: function(options, callback) {
        request("post", api.getCosCredentialsByScene, {
            scene: 'info_report',
            ext_info: {
                openid: store.state.userOpenId
            }
        })
        .then(data => {
            callback({
                TmpSecretId: data.data.credentials.tmp_secret_id,
                TmpSecretKey: data.data.credentials.tmp_secret_key,
                SecurityToken: data.data.credentials.session_token,
                ExpiredTime: data.data.credentials.expired_time
            });
        }).catch(() => {
            Notify.warn('存储初始化失败,请重试');
            data.firstSubmitEvent = true;
            data.loading = false;
        });
    }
});

data.isH5 = store.state.isH5;
const u = navigator.userAgent;
data.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
watch(() => [
    data.formData.locationName, 
    data.formData.userLatLng, 
    data.formData.locationVideo, 
    data.formData.locationPics, 
    data.formData.businessPhone, 
    data.formData.locationPassReason, 
    data.locationTypeSelectClick], newV => {
    switch (data.pageType) {
        // 新增
        case '1': {
            let bool = true;
            if (newV[0] == '' || newV[0] == undefined){
                bool = false
            }
            if(newV[1] == '' || newV[1] == undefined) {
                bool = false
            }
            if (newV[2][0].src == '') {
                bool = false
            }
            if (newV[3][0].src == '') {
                bool = false
            }
            if (newV[4] == '') {
                businessDelButtonType.value = 'businessPhonePic'
                resetBusinessInfo()
            }
            const arr = data.addLocationTypeSelect.every(item => item.select == false)
            if (arr == true && !data.isInternalUser) {
                bool = false
            }
            if (bool) {
                data.userFillInComplete = true
            }
        }

            break;
        // 过期
        case '2': {
            let bool = true;
            if (newV[5] == '' || newV[5] == undefined) {
                bool = false
            }
            if (newV[0] == '' || newV[0] == undefined) {
                bool = false
            }
            if (newV[2][0].src == '') {
                bool = false
            }
            if (newV[3][0].src == '') {
                bool = false
            }
            const arr = data.addLocationTypeSelect.every(item => item.select == false)
            if (arr == true && !data.isInternalUser) {
                bool = false
            }
            if (bool) {
                data.userFillInComplete = true
            }
        }

            break;
        // 该要素
        case '3': {
            let bool = true;
            if (newV[0] == '' || newV[0] == undefined) {
                bool = false
            }
            if (newV[2][0].src == '') {
                bool = false
            }
            if (newV[3][0].src == '') {
                bool = false
            }
            if (newV[4] == '') {
                businessDelButtonType.value = 'businessPhonePic'
                resetBusinessInfo()
            }
            const arr = data.addLocationTypeSelect.every(item => item.select == false)
            if (arr == true && !data.isInternalUser) {
                bool = false
            }
            if (bool) {
                data.userFillInComplete = true
            }
        }

            break;

        default:
            break;
    }
}, {
    deep: true
})

onBeforeRouteLeave((to, from, next) => {
    if (!data.isAllowExit) {
        if (data.showPreviewImg) {
            data.showPreviewImg = false;
            data.showPreviewVideo = false;
            next(false)
        }
        const { href, query } = from;
        if(useSelectTimePopup.value == true){
            useSelectTimePopup.value = false
            next(false)
        }
        if(selectBusinessDatePopup.value == true){
            selectBusinessDatePopup.value = false
            next(false)
        }
        if (
            href.includes("add_location_detail") &&
            query.from === 'index'
        ) {
            if(data.loading == false && data.notAllowReport == false){
                store.dispatch("setMessageAppearDetailVisble", true);
                next(false)
            }
        }
    }
    if(data.map && data.pageType == '3'){
        data.map.destroy()
    }
    next()
})

const debounce = (fn, delay) => {
    let timer
    return function () {
        let arg = arguments
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn(...arg)
        }, delay)
    }
}
// const changetono = () => {
//     data.locshow = false;
// } 
onBeforeMount(() => {
    // if(store.state.isH5 && isPlatformPC()){
    //     wx.miniProgram.switchTab({
    //         url: '/pages/userHomePage/userHomePage'
    //     })
    //     return
    // }
    if(store.state.fullpath != 'no' && store.state.isH5) {
        // resroute();
          // console.log(router, 'rputer.go(-1)');
          // const hostory = router.getRoutes();
          // console.log(hostory, '"http://192.168.43.96:3000/message_appear_detail?type=h5page&isStaff=true&location=39.90"')
          const rt = JSON.parse(localStorage.getItem('data'))
          // if(rt.ro == "sss") {
          //   rt.to = 'ty'
          //   localStorage.setItem('data', JSON.stringify(rt))
          //   router.go(-1);
          // }
          
        data.pageType = rt.pageType;
        data.newAddLocationList.map(item => {
            if (item.value == data.pageType) {
                data.mapTitle = item.userSelectLatLngTitle
            }
        })
        // 初始化数据
        resetFromData()
        if(rt){
            Object.keys(rt).forEach(key => {
                if(key == 'businessTimeAdd') {
                    return;
                }
                data[key] = rt[key]
            })
        }
        data.userFillInComplete = true
        if (store.state.islattest) {
            return;
        }
        // data.formData.locationName
        if (data.pageType == '3' && store.state.newPoi == 'true') {
        // 将该要素修改成新增
            data.loading = true
            data.pageType = '1'
            data.isAllowExit = false
            data.userCheckDetail = false
            data.mapTitle = '确认地点所在位置'
            data.vue315Title = '地点新增'
            locationAddTypeSelect({ lng: data.latlng.split(',')[1], lat: data.latlng.split(',')[0] })
            const business = document.getElementById('business')
            const location = document.getElementById('location')
            const businessPreviousSibling = business.previousSibling
            businessPreviousSibling.after(location)
            Toast.text('已为您跳转至地点新增模块~')
            $forceUpdate()
        }
        let userltlg = store.state.location.split(',');
        data.userLocation = {
            latitude: userltlg[0] - 0,
            longitude: userltlg[1] - 0
        }
        // 给地图查看点赋值
        let wxdat = JSON.parse(store.state.reportSearchWX);
        if(store.state.reportSearchWX && store.state.search == 'false') {
            data.userSelectedLngLat = {
              lng: wxdat.longitude,
              lat: wxdat.latitude
            };
            data.formData.userSelectLocationName = wxdat.content
            data.userSelectPoint = true
            data.formData.userLatLng = `${wxdat.latitude},${wxdat.longitude}`;
            data.photoLatLng = data.formData.userLatLng;
            // store.commit('setlocation', data.formData.userLatLng)
        } else if(store.state.reportSearchWX && store.state.search == 'true') {
            data.userSelectedLngLat = {
                lng: wxdat.location.lng,
                lat: wxdat.location.lat
            };
            data.formData.userSelectLocationName = wxdat.address
            if(store.state.newPoi) {
                data.type ='add'
            }
            data.formData.userLatLng = `${wxdat.location.lat},${wxdat.location.lng}`;
            data.formData.locationName = wxdat.title;
            //   data.href = `http://apis.map.qq.com/tools/locpicker?search=0&mapdraggable=0&total=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${data.formData.userLatLng}`
        }
        if(data.pageType == '2'){
            data.photoLatLng = data.formData.userLatLng;
        }
        //   距离验证
         
          //   locationToLatLng(data.userSelectedLngLat.lat, data.userSelectedLngLat.lng)
        //   data.href = `http://apis.map.qq.com/tools/locpicker?search=0&mapdraggable=0&total=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${data.formData.userLatLng}`
         
          //   else  {
        //     data.userSelectedLngLat = {
        //       lng: data.message.lng,
        //       lat: data.message.lat
        //     };
        // }
        // 看这里
        // data.message ???
        data.scrollTop = rt.scrollTop;
        //   data.showloc = true;
        return;
    }
    document.documentElement.scrollTop = 0;
    if(store.state.isH5 && route.query.from != "history") {

        data.locationDownLine.map(item => item.select = false)
        data.pageType = data.newAddLocationList[store.state.pagelevel * 1].value || '1'
        data.userCheckDetail = false;
        let r = data.newAddLocationList[store.state.pagelevel * 1].userSelectLatLngTitle;
        data.mapTitle = r ?
            decodeURIComponent(r) : ''
    } else if (route.query.from == 'index') {
        data.locationDownLine.map(item => item.select = false)
        data.pageType = route.query.value ? route.query.value : '1'
        data.userCheckDetail = false;
        data.mapTitle = route.query.mapTitle ?
            decodeURIComponent(route.query.mapTitle) : ''
    } else if (route.query.from == "history") {
        data.userCheckDetail = true
        if(route.params.auditStatus != "审核中"){
            data.isAuditNoPass = true
            data.checkDescription = route.params.checkDescription == '' ? '但部分类别为不合格' : route.params.checkDescription
            const radio_select = JSON.parse(route.params.innerCheckResult).radio_select
            if(radio_select == 0){
                // 银河要素审核结论
                data.innerCheckResult = route.params.innerCheckResult ? JSON.parse(route.params.innerCheckResult).checkContent : {}
                // 筑巢要素审核结论
                data.checkResult = route.params.checkResult ? JSON.parse(route.params.checkResult) : {}
                // 根据银河和筑巢审核结论填写不合格原因和判断各要素是否合格
                setCheckContentAndResult(data.innerCheckResult, data.checkResult)
            }else{
            // 银河审核不合格
                data.checkDescription = radioSelect.filter(item => item.key == radio_select)[0].value
            }
        }
        data.pageType = route.params.pageType - 0 - 3;
        data.newAddLocationList.map(item => {
            if (item.value == data.pageType) {
                data.mapTitle = item.userSelectLatLngTitle
            }
        })
        resetFromData()
        data.userFillInComplete = true
        getReportData(route.params.cosUrl)
        // data.formData.locationName
    }
    switch (data.pageType) {
        case '1':
        case 1:
            data.vue315Title = '地点新增'
            break;
        case '2':
        case 2:
            data.vue315Title = '地点不存在'
            break;
        case '3':
        case 3:
            data.vue315Title = '地点信息更改'

            break;

        default:
            break;
    }
    if (easyearn && !data.userCheckDetail) {
        const obj = JSON.parse(easyearn.getUserLocation())
        if(obj.latitude == 0 && obj.longitude == 0) {
            data.notAllowReportText = '请开启定位权限'
            data.notAllowReport = true
            return
        }
        // 拍摄图片和视频时用
        data.userLocation = obj
        // 通过坐标获取用户所在区域的可新增类型
        if (data.pageType == '3') {
            // 该要素 去获取用户当前地址
            // getUserLocationInfo2({ lng: obj.longitude, lat: obj.latitude, type: 'map' })
            setTimeout(() => {
                locationAddTypeSelect({ lng: obj.longitude, lat: obj.latitude })
            }, 50)
        } else {
            locationAddTypeSelect({ lng: obj.longitude, lat: obj.latitude })
        }
        data.latlng = `${obj.latitude},${obj.longitude}`
        let getUserLevel = {
            common: {
                "vcode": "31000008",
                "version": "3.10.0",
            },
        }
        let openId = store.getters.userInfo ?
            store.getters.userInfo.split('/')[0] : null;
        data.haveOpenId ? getUserLevel['common']['openid'] = openId : ''
        request('post', api2.userLevelInfoH5, getUserLevel).then(levelRes => {
            if (levelRes.code == 0) {
                data.userLevel = levelRes.data.currentLevel
            }
        })
    }
    data.controlpictoweixin = false;
})
// eslint-disable-next-line no-unused-vars
const tochangepic = () => {
    let locLatLn = data.formData.userLatLng.split(',');
    const userLat = locLatLn[0] - 0;
    const userLng = locLatLn[1] - 0;
    let userltlg = store.state.location.split(',');
    const lat = userltlg[0] - 0;
    const lng = userltlg[1] - 0;
    const Distance = Number(utils.getDistance(userLat, userLng, lat, lng))
    const formDataValue = data.formData[data.userClickPic]
    // let nu = formDataValue.length - data.photonum - 1
    //     formDataValue.splice(nu, data.photonum)
    if(Distance > 100){
        if(data.pageType == '1'){
            Toast.text('您当前的位置距离戳点位置超过100米，请走近拍摄～', {
                duration: 1000
            })
        }else{
            Toast.text('您当前的位置距离店铺位置超过100米，请走近拍摄～', {
                duration: 1000
            })
        }
        let nu = formDataValue.length - data.photonum - 1
        formDataValue.splice(nu, data.photonum)
        store.commit('SET_islattest', false)
        // return
    }

};
window.getParameter = () => {
      // data.showPreviewImg = val;
      return data.timestamp;
    };
const locationAddTypeSelect = ({ lng, lat }) => {
    let arr = []
    citys.map(item => {
        arr.push({
            label: item.label,
            value: item.value
        });
        if (item.children) {
            item.children.map(childrenItem => {
                arr.push({
                    label: childrenItem.label,
                    value: childrenItem.value
                });
                if (childrenItem.children) {
                    childrenItem.children.map(child => {
                        arr.push({
                            label: child.label,
                            value: child.value
                        });
                    });
                }
            });
        }
    });
    let classifyArr = []
    classifyLists.map(item => {
        classifyArr.push({
            label: item.label,
            value: item.value
        });
        if (item.children) {
            item.children.map(childrenItem => {
                classifyArr.push({
                    label: childrenItem.label,
                    value: childrenItem.value
                });
                if (childrenItem.children) {
                    childrenItem.children.map(child => {
                        classifyArr.push({
                            label: child.label,
                            value: child.value
                        });
                    });
                }
            });
        }
    });
    data.cityArrayFlat = arr
    data.classifyFlat = classifyArr
    if (!data.userCheckDetail) {
        getUserLocationInfo({ lng, lat, type: 'select' })
    } else {
        getUserLocationInfo({ lng, lat, type: 'history' })
    }
}

onMounted(() => {
     if (store.state.islattest) {
            data.controlpictoweixin = false;
              tochangepic()
            //   data.
            // LocationVideo.value.logList(data.formData.LocationVideo[0].src, 0)
            data.formData['locationVideo'].forEach((item, index) => {
                LocationVideo.value.logList(item.src, index)
            })
            //   LocationVideo.value.logList(data.formData['locationVideo'][0].src, 0)
            //   recivePicPathGetUrl(resItem.url, srcNullIndex + resIndex, data.userClickPic);
          }
    data.timestamp = new Date().getTime().toString(); // 时间戳
    if(store.state.fullpath != 'no' && store.state.isH5 && (data.pageType == '2' || data.pageType == '3') ) {
    // if(store.state.isH5 && (data.pageType == '2' || data.pageType == '3') ) {
        if(!data.map && data.pageType == '3') {
                        data.map = new TMap.Map("map", {    
                            id: 'map',
                            zoom: 16,//设置地图缩放级别  new TMap.LatLng(data.latlng.split(',')[0], data.latlng.split(',')[1])
                            center: new TMap.LatLng(39.984104, 116.307503)//设置地图中心点坐标
                        });
                    }
        locationToLatLng(data.userSelectedLngLat.lat, data.userSelectedLngLat.lng)
    }
    window.addEventListener('message', function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        console.log(loc, 'event.data-message');
        if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          data.latlng = `${loc.latlng.lat},${loc.latlng.lng}`;
          data.formData.userLatLng = {
            ...loc.latlng
          }
        }
    }, false);
    if(data.scrollTop * 1 > 0) {
        document.getElementsByClassName('allstyle')[0].scrollTo(0, data.scrollTop);
    }
    setTimeout(() => {
            data.scrollTop = 0;
          }, 500)
    if(data.isH5) {
        // localStorage.removeItem('data');
        store.commit('SET_fullpath', 'no');
        data.loading = false;
    }
    if (store.state.isH5) {
        data.isInternalUser = store.state.isStaff
    } else {
        data.isInternalUser = store.state.isInternalUser
    }
    if (data.pageType == '1') {
        const business = document.getElementById('business')
        const location = document.getElementById('location')
        const businessPreviousSibling = business.previousSibling
        businessPreviousSibling.after(location)
    } 
    if (easyearn || data.isH5) {
        if (data.pageType == '3' && !data.userCheckDetail) {
            setTimeout(() => {
                if(!data.map) {
                    data.map = new TMap.Map("map", {
                        id: 'map',
                        zoom: 16,//设置地图缩放级别  new TMap.LatLng(data.latlng.split(',')[0], data.latlng.split(',')[1])
                        center: new TMap.LatLng(39.984104, 116.307503)//设置地图中心点坐标
                    });
                }
                if(store.state.fullpath != 'no' && store.state.isH5) {
                        locationToLatLng(data.userSelectedLngLat.lat, data.userSelectedLngLat.lng)
                }
                nextTick(() => {
                    let rotate_circle = document.getElementsByClassName('rotate-circle')
                    let tmap_zoom_control = document.getElementsByClassName('tmap-zoom-control')
                    if (rotate_circle) {
                        rotate_circle[0].style.cssText = 'display: none;'
                    }
                    if (tmap_zoom_control) {
                        tmap_zoom_control[0].style.cssText = 'display: none;'
                    }
                    let logo = document.querySelector('#map > div > div:nth-child(2)');
                    if(logo){
                        logo.setAttribute('style', 'display: none;');
                    }
                })
            }, 50);
        }
    }
})

// 获取地点名称
const locationNameGet = () => {
    if (data.userCheckDetail) return
    if(!data.isH5){
        if (easyearn) {
            // 通过data.pageType映射poiReportSearch值
            let arr = new Map([
                ['1', 1],
                ['3', 2],
                ['2', 3],
            ])
            console.log(arr.get(data.pageType), 'arr.get(data.pageType)');
            const versionCode = easyearn.getVersionCode()
            // 根据版本号做版本兼容
            if(versionCode > 32601006){
                easyearn.poiReportSearch(arr.get(data.pageType), data.formData.locationName)
            }else{
                easyearn.poiReportSearch(arr.get(data.pageType))
            }
        }
    }else{
        if(data.datayime) {
        //   goweixin();
          goweixin('name')
          data.datayime = false;
          setTimeout(() => {data.datayime = true } ,3000)
        }
    }
}
// 用户选择地点名称后赋值
// 客户端给的地点名称
window.onLocationAdded = (poiName, addressName, poiType, lat, lng) => {
    console.log(poiName, poiType, addressName, lat, lng, 'onlocationAddedf');
    data.formData.locationName = poiName.replace(/\s*/g,"");
    /*
        1 新增
        2 过期
        3 该要素
    */
    if (data.pageType == '3' && poiType == '1') {
        // 将该要素修改成新增
        data.loading = true
        data.pageType = '1'
        data.isAllowExit = false
        data.userCheckDetail = false
        data.mapTitle = '确认地点所在位置'
        data.vue315Title = '地点新增'
        locationAddTypeSelect({ lng: data.latlng.split(',')[1], lat: data.latlng.split(',')[0] })
        const business = document.getElementById('business')
        const location = document.getElementById('location')
        const businessPreviousSibling = business.previousSibling
        businessPreviousSibling.after(location)
        Toast.text('已为您跳转至地点新增模块~')
        $forceUpdate()
    }
    if(data.pageType == '3' || data.pageType == '2'){
        if(lat && lng){
            locationToLatLng(lat, lng)
        }else{
            locationToLatLng(data.latlng.split(',')[0], data.latlng.split(',')[1])
        }
    }
}
// 清空营业图片
/**
 * 
 * @param {*} type businessPhonePic businessTimePic
 */
const resetBusinessInfo = () => {
    switch (businessDelButtonType.value) {
        // 营业日期(通过营业日期删除营业时间照)
        case 'businessTimePic':{
            data.formData.businessTimePic = [
                {
                    index: 1,
                    type: 'businessTimePic',
                    src: '',
                    srcCopy: '',
                    title: '营业时间照',
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                }
            ]
            data.businessDateArr = []
            data.formData.businessDate = '请选择'
            selectBusinessDatePopup.value = false
            break;
        }
        // 营业电话
        default:{
            data.formData.businessPhonePic = [
                {
                    index: 1,
                    src: '',
                    type: 'businessPhonePic',
                    srcCopy: '',
                    title: '营业电话照',
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                }
            ]
            data.formData.businessPhone = ''
            break;
        }
    }
    showBusinessDelPopup.value = false
}

// 地址转坐标
const locationToLatLng = (lat, lng) => {
    // let sig = md5(`/ws/geocoder/v1?address=${name}&callback=jsonpCallback&key=${key}&output=jsonp${sk}`)
    // sig = encodeURI(sig)
    // jsonp(`${webServerApiGetInfo}`, {
    //     callbackQuery: 'callback',
    //     callbackName: 'jsonpCallback',
    //     key,
    //     address: name,
    //     output: 'jsonp',
    //     sig, // sig参数参考 https://lbs.qq.com/faq/serverFaq/webServiceKey
    // }).then(res => {
    //     if(res.result){
    //         // 没有戳点的用户传地点名称的坐标
    //         const location = res.result.location
            data.photoLatLng = `${lat},${lng}`
            // if (data.isH5) {
                // data.photoLatLng = store.state.location;
                // location = store.state.location;
                console.log(location);
            // }
            if(data.pageType == '3'){
                const markerGeo = {
                    id: 'center',
                    position: new TMap.LatLng(lat, lng),
                };
                if(data.marker){
                    data.marker.setMap(null)
                    data.marker = null;
                }
                data.marker = new TMap.MultiMarker({
                    map: data.map,
                    styles: {
                        // 点标记样式
                        marker: new TMap.MarkerStyle({
                            width: 20, // 样式宽
                            height: 30, // 样式高
                            anchor: { x: 10, y: 15 }, // 描点位置
                        }),
                    },
                    geometries: [
                        markerGeo
                    ],
                });
                getUserLocationInfo2({ lng: markerGeo.position.lng, lat: markerGeo.position.lat, type: 'map' })
                data.map.setCenter(new TMap.LatLng(lat * 1, lng * 1))
            }
            if(data.pageType == '2'){
                getUserLocationInfo2({ lng: lng, lat: lat, type: 'add' })
            }
    //     }
    // })
}
// 清空电话和日期
const resetBusinessPhone = (type) => {
    showBusinessDelPopup.value = true
    businessDelButtonType.value = type
}
const tDelIconClick = (type) => {
    setTimeout(() => {
        switch (type) {
            case 'businessPhone':
                data.showBusinessPhoneIcon = false
                break;
            case 'locationNewName':
                data.showLocationNewNameIcon = false
                break;
        
            default:
                break;
        }
    }, 100)
}
// 营业电话
const businessPhoneFocus = (number) => {
    if ( /Android/gi.test(navigator.userAgent)) {
        const innerHeight = window.innerHeight;
        window.addEventListener('resize',()=>{
            const newInnerHeight = window.innerHeight;
            if ( innerHeight > newInnerHeight) {
                //键盘弹出事件处理
                data.isShowFillInBtn = false
            }else {
                //键盘收起事件处理
                data.isShowFillInBtn = true
            }
        });
    }else {
        window.addEventListener('focusin ',() =>{//键盘弹出事件处理
            data.isShowFillInBtn = false
        });
        window .addEventListener('focusout',()=>{//键盘收起事件处理
            data.isShowFillInBtn = true
        });
    }
    switch (number) {
        case 1:
            data.showLocationNewNameIcon = true
            break;
        case 2:
            data.showBusinessPhoneIcon = true
            break;
    
        default:
            break;
    }
}

// 获取坐标位置信息
const getUserLocationInfo2 = debounce(({ lng, lat, type }) => {
    // 通过坐标获取店铺信息
    let location = `${lat},${lng}`
    // if (data.isH5) {
    //     location = store.state.location;
    // }
    console.log(location);
    // md5保持原生数据
    let sig = md5(`/ws/place/v1/search?boundary=nearby(${location},1000)&callback=jsonpCallback&key=${key}&keyword=${data.formData.locationName}&output=jsonp${sk}`)
    sig = encodeURI(sig)
    jsonp(`${webServerApiGetInfo2}`, {
        //重点来了
        //腾讯的api上有个callback参数，这是使用指定回调函数
        //使用vue-jsonp时这个参数需要通过callbackQuery和callbackName来设置
        //否vue-jsonp会随机生成一个callback参数这样无论怎么弄都会报签名校验失败
        // 设置callback参数的key  不设置的话callback参数会自动被赋予一个随机值  md5校验无法通过
        callbackQuery: 'callback',
        // 设置callback 参数的值
        callbackName: 'jsonpCallback',
        //其他参数正常传
        key,
        boundary: `nearby(${location},1000)`,
        keyword: `${data.formData.locationName}`,
        output: 'jsonp',
        sig, // sig参数参考 https://lbs.qq.com/faq/serverFaq/webServiceKey
    })
    .then(res => {
        // 通过坐标得到改坐标信息
        console.log('坐标解析IP', res)
        if(res.data){
            if (type == 'map') {
                let obj = {}
                let obj1 = {}
                const result = res.data
                obj = {
                    name: result[0].address,
                    title: false
                }
                obj1 = {
                    name: result[0].category.replace(/:/g, '/'),
                    title: false
                }
                data.mapInfo = [
                    {
                        name: result[0].title,
                        title: true
                    },
                    obj,
                    obj1
                ]
                data.locationPid = result[0].id
            }
            if (type == 'add') {
                const result = res.data
                data.locationPid = result[0].id
                data.formData.userSelectLocationName = result[0].address
            }
        }
    })
}, 300)

// 获取信息
const getUserLocationInfo = debounce(({ lng, lat, type }) => {
    // 通过坐标获取店铺信息

    let location = `${lat},${lng}`
    if (data.isH5) {
        location = store.state.location;
        console.log(location);
    }
    // md5保持原生数据
    let sig = md5(`/ws/geocoder/v1?callback=jsonpCallback&get_poi=1&key=${key}&location=${location}&output=jsonp${sk}`)
    sig = encodeURI(sig)
    jsonp(`${webServerApiGetInfo}`, {
        //重点来了
        //腾讯的api上有个callback参数，这是使用指定回调函数
        //使用vue-jsonp时这个参数需要通过callbackQuery和callbackName来设置
        //否vue-jsonp会随机生成一个callback参数这样无论怎么弄都会报签名校验失败
        // 设置callback参数的key  不设置的话callback参数会自动被赋予一个随机值  md5校验无法通过
        callbackQuery: 'callback',
        // 设置callback 参数的值
        callbackName: 'jsonpCallback',
        //其他参数正常传
        key,
        location, 
        get_poi: '1',
        output: 'jsonp',
        sig, // sig参数参考 https://lbs.qq.com/faq/serverFaq/webServiceKey
    })
        .then(res => {
            // 通过坐标得到改坐标信息
            console.log('ip地址', res)
            if(res.result){
                if (type == 'select') {
                    let adcode = []
                    const address = res.result.address_component
                    // data.cityArrayFlat.map(item => {
                    //     if (item.label == address.province) {
                    //         adcode.push(item.value)
                    //     }
                    //     if (item.label == address.city) {
                    //         adcode.push(item.value)
                    //     }
                    //     if (address.district && item.label == address.district) {
                    //         adcode.push(item.value)
                    //     }
                    // })
                    citys.map(item => {
                        if(item.label == address.province){
                            adcode.push(item.value)
                            item.children && item.children.map(child => {
                                if (child.label == address.city) {
                                    adcode.push(child.value)
                                    child.children && child.children.map(child2 => {
                                        if (address.district && child2.label == address.district) {
                                            adcode.push(child2.value)
                                        }
                                    })
                                }
                            })
                        }
                    })
                    data.userLocationADCode = [...new Set(adcode)].join(',')
                    if(!data.isInternalUser){
                        // 通过获取的adcode去获取银河上配置的情报
                        getYinHeIntellgenceConf()
                    }else{
                        data.loading = false
                    }
                }
                if (type == 'history') {
                    data.formData.userSelectLocationName = res.result.address
                }
                if (type == 'add') {    
                    data.formData.userSelectLocationName = res.result.address
                }
            }
        })
}, 300)
// 图片选完后Android 端通知回调JS端
window.onRecivePoiPicPath = res => {
    data.judge = res[0].url.indexOf('ishare-10003415')
    const formDataValue = data.formData[data.userClickPic]
    const srcNullIndex = formDataValue.findIndex(item => item.src === '')
    if (srcNullIndex >= 0) {
        formDataValue.splice(srcNullIndex, 1)
    }
    res.map((resItem, resIndex) => {
        let obj = {
            index: formDataValue.length + resIndex,
            src: resItem.url,
            srcCopy: resItem.url,
            title: formDataValue.length == 0 ?  
            formDataPicAndVideoTransf.get(data.userClickPic) : '补充照',
            lat: resItem.lat,
            lng: resItem.lng,
            angle: resItem.angle,
            time: resItem.time,
            text: '',
            type: data.userClickPic,
        }
        formDataValue.push(obj)
        setTimeout(() => {
            recivePicPathGetUrl(resItem.url, srcNullIndex + resIndex, data.userClickPic);
        }, 50);
    })
    if (formDataValue.length < 10) {
        let obj = {
            index: formDataValue.length + 1,
            src: '',
            srcCopy: '',
            title: '补充照',
            lat: '',
            lng: '',
            angle: '',
            time: '',
            text: '',
            type: data.userClickPic,
        }
        formDataValue.push(obj)
    }
};
// 拍视频
window.shootVideoCallback = ({url, locations}) => {
    console.log(url);
    console.log(locations, 'locations');
    // res
    data.judge = url.indexOf('ishare-10003415');
    let arrLocation = [];
    locations.forEach(item => {
        arrLocation.push({
            lat: String(item.lat),
            lng: String(item.lng),
            timestamp: String(item.time),
            angle: String(item.direction)
        })
    });
    data.formData[data.userClickPic][data.userClickCurrent] = {
        ...data.formData[data.userClickPic][data.userClickCurrent],
        src: url,
        srcCopy: url,
        lat: arrLocation[0].lat || "",
        lng: arrLocation[0].lng || "",
        time: arrLocation[0].timestamp || "",
        angle: arrLocation[0].angle || "",
        tracks: arrLocation,
    }
    recivePicPathGetUrl(url, data.userClickCurrent, data.userClickPic);
    const type = data.userClickPic
    const arr = data.formData[type].filter(item => item.type == data.userClickPic)
    if (arr.length < 5) {
        data.formData[type].push({
            index: data.formData[type].length + 1,
            src: '',
            srcCopy: '',
            title: formDataPicAndVideoTransf.get(data.userClickPic),
            lat: '',
            type: data.userClickPic,
            lng: '',
            angle: '',
            time: '',
            tracks: [],
            text: '',
            poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
        })
    }
}
// 过期验证下线原因
const locationPassReasonBtn = (value, index) => {
    if (data.userCheckDetail) return
    data.locationDownLine.forEach(item => item.select = false)
    data.locationDownLine[index].select = true
    data.formData['locationPassReason'] = value
}
// 获取银河上的情报配置
const getYinHeIntellgenceConf = () => {
    const EnableTimeEnd = toYYMMDDHMS(new Date())
    request('get', `${api.confList}?location=${data.userLocationADCode}&state=2&EnableTimeEnd=${EnableTimeEnd}`).then(res => {
        console.log(res);
        if (res.code == 0 && res.data.length == 0
        && route.params.from != 'history') {
            data.loading = false
            data.notAllowReportText = '该区域暂未开放上报，请留意平台后续运营通知~'
            data.notAllowReport = true;
            data.isAllowExit = true; 
        }
        if (res.code == 0 && res.data.length > 0) {
            const resData = res.data
            let arr = [] // 地点
            let arr2 = [] // 分类
            let index = 0; // 检测等级
            let indexArr = []; // 检测等级
            resData.map(item => {
                if (item.specifyUser && (item.group == 4 || item.group == 3) &&
                !item.specifyUser.includes(store.getters.userInfo.split('/')[0])) {
                    return
                }
                let timeStart = new Date(item.enableTimeStart).getTime()
                let timeEnd = new Date(item.enableTimeEnd).getTime()
                let nowTime = new Date().getTime()
                if (item.state == '2' && item.type.includes(data.pageType)
                    && (nowTime < timeEnd && nowTime > timeStart)) {
                    index ++; // 看有多少是复合展示要求的（不包括等级限制）
                    if (Number(data.userLevel) < Number(item.levelLimit)) {
                        indexArr.push(item)
                    }
                    const classifyArr = item.classify.split(',');
                    [...new Set(classifyArr)].map(classifyItem => {
                        let classifyItemCpoy = JSON.parse(JSON.stringify(classifyItem))
                        classifyItemCpoy = classifyItemCpoy.includes('自定义') ?
                            '10' : classifyItemCpoy
                        data.classifyFlat.map((listItem) => {
                            switch (listItem.value) {
                                case classifyItemCpoy:
                                    if (classifyItemCpoy == '10') {
                                        arr2.push({
                                            label: classifyItem.split('-')[1],
                                            value: listItem.value
                                        })
                                    } else {
                                        arr2.push({
                                            label: listItem.label,
                                            value: listItem.value
                                        })
                                    }
                                    break;
                                default:
                                    break;
                            }
                        })
                    });
                    const location = item.location.split(',');
                    [...new Set(location)].map(valueItem => {
                        if(data.userLocationADCode.includes(valueItem)){
                            let locationArr = []
                            data.cityArrayFlat.map(cityItem => {
                                switch (cityItem.value) {
                                    case '0':
                                        locationArr[0] = '全国'
                                        break;
                                    case valueItem:
                                        locationArr[0] = cityItem.label
                                        break;
                                    default:
                                        break;
                                }
                            })
                            arr2.map(arr2item => {
                                arr.push({
                                    label: locationArr[0] + arr2item.label,
                                    value: `${valueItem},${arr2item.value}`,
                                    reportGroup: `${arr2item.value}`,
                                    className: 'locationType',
                                    select: false,
                                    confId: item.confId
                                })
                            })
                        }
                    })

                }
            })
            if (arr.length == 0 && route.params.from != 'history') {
                data.loading = false
                data.notAllowReportText = '该区域暂未开放上报，请留意平台后续运营通知~'
                data.notAllowReport = true;
                data.isAllowExit = true;
            }
            if(index == indexArr.length && index != 0){
                data.loading = false
                data.notAllowReportText = '您当前的等级暂时无法参与，请提升等级后参与~'
                data.notAllowReport = true;
                return
            }
            // 数组去重
            let setArr = []
            setArr = arr.filter((item, index) => arr.findIndex(i => i.label === item.label) === index);
            data.addLocationTypeSelect = setArr;
            data.loading = false
        }
    }).catch(err => {
        console.log(err, 'errConfList');
    })
}
const recivePicPathGetUrl = (url, index, typeKey) => {
    // let key = url.split(".com/")[1];
    data.judge = url.indexOf('ishare-10003415')
    const url2 = url.includes('http') ? url : `https://${url}`
    window.getReadOnlyPresignedUrlApi(url2).then(resUrl => {
        console.log(resUrl, 'url');
        data.formData[typeKey].map((item, mapIndex) => {
            if (item.type === typeKey && mapIndex == index) {
                item.src = resUrl
            }
        })
        if(typeKey == 'locationVideo'){
            LocationVideo.value.logList(resUrl, index)
        }
        setTimeout(() => {
            if(data.controlpictoweixin) {
                goweixin('photo');
            }
        }, 500);
    }).catch(err => console.log(err, 'err'));
}

// 获取上报数据
const getReportData = (url) => {
    // let key = url.split(".com/")[1];
    data.judge = url.indexOf('ishare-10003415')
    const url2 = url.includes('http') ? url : `https://${url}`
    window.getReadOnlyPresignedUrlApi(url2).then(resUrl => {
        request("get", resUrl).then(res => {
            console.log(res, 'res');
            if (res) {
                // 在新增的时候是否展示更多信息标题
                let showMoreTitle = {
                    businessTime: true,
                    businessDate: true,
                    businessTimePics: true,
                    businessPhone: true,
                    businessPhonePics: true,
                }
                const body = res
                console.log(body);
                data.href = `http://apis.map.qq.com/tools/locpicker?search=0&mapdraggable=0&total=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${body.userLatLng}`
                data.latlng = `${body.userLatLng.split(',')[0]},${body.userLatLng.split(',')[1]}`
                data.formData.userLatLng = `${body.userLatLng.split(',')[0]},${body.userLatLng.split(',')[1]}`
                locationAddTypeSelect({ lng: body.userLatLng.split(',')[1], lat: body.userLatLng.split(',')[0] })
                const reportGroup = body.reportGroup.split(',')[1]
                const location = body.reportGroup.split(',')[0]
                let addLocationTypeSelect = []
                data.cityArrayFlat.map(cityItem => {
                    if (cityItem.value == location) {
                        addLocationTypeSelect.push(cityItem.label)
                    }
                })
                data.classifyFlat.map(classifyItem => {
                    if (classifyItem.value == reportGroup) {
                        addLocationTypeSelect.push(classifyItem.label)
                    }
                })
                data.addLocationTypeSelect = [{
                    label: addLocationTypeSelect.join(''),
                    value: location + ',' + reportGroup,
                    select: true
                }]
                // 设置戳点完成
                data.userSelectPoint = true;
                data.formData.locationName = body.location ? body.location : body.locationName;
                data.formData.userSelectDetailLocation = body.locationAddress;
                data.formData.locationNewName = body.locationNewName;
                data.formData.userComment = body.userComment
                data.locationDownLine.forEach(item => item.select = false);
                data.formData.businessTime = []
                if(body.businessTimePics.length == 0){
                    showMoreTitle.businessTimePics = false
                }
                if(body.businessTime == ''){
                    showMoreTitle.businessTime = false
                }else{
                    const arr = []
                    body.businessTime.split(';').map(timeAll => {
                        arr.push({
                            start: timeAll.split('-')[0],
                            end: timeAll.split('-')[1],
                        })
                        
                    })
                    data.formData.businessTime = arr
                }
                if(body.businessPhonePics.length == 0){
                    showMoreTitle.businessPhonePics = false
                }
                if(body.businessPhone === ''){
                    showMoreTitle.businessPhone = false
                }else{
                    data.formData.businessPhone = body.businessPhone
                }
                
                if (data.pageType == '2') {
                    data.locationDownLine.forEach(item => {
                        if (item.value == body.locationPassReason) {
                            data.formData.locationPassReason = item.value;
                            item.select = true
                        }
                    })
                }
                userCheckHandlePicAndVideoData(body, 'locationPics')
                setTimeout(() => {
                    userCheckHandlePicAndVideoData(body, 'locationVideo')
                }, 40);
                setTimeout(() => {
                    userCheckHandlePicAndVideoData(body, 'businessPhonePic')
                }, 80);
                setTimeout(() => {
                    userCheckHandlePicAndVideoData(body, 'businessTimePic')
                }, 120);
                if (body.businessDate) {
                    let arr = []
                    data.columns.map(columnsitem => {
                        body.businessDate.split(',').map(weekItem => {
                            if (columnsitem.value == weekItem) {
                                arr.push(columnsitem.text)
                            }
                        })
                    })
                    if(arr.length == 0){
                        showMoreTitle.businessDate = false
                    }
                    if(arr.length == 7){
                        data.formData.businessDate = '周一至周日'
                    }else{
                        data.formData.businessDate = arr.join('， ')
                    }
                }
                if (data.pageType == '3') {
                    data.map = new TMap.Map("map", {
                        id: 'map',
                        zoom: 16,//设置地图缩放级别
                        center: new TMap.LatLng(data.latlng.split(',')[0], data.latlng.split(',')[1])//设置地图中心点坐标
                    });
                    let rotate_circle = document.getElementsByClassName('rotate-circle')
                    if (rotate_circle) {
                        rotate_circle[0].style.cssText = 'display: none;'
                    }
                    const markerGeo = {
                        id: 'center',
                        position: data.map.getCenter(),
                    };
                    data.marker = new TMap.MultiMarker({
                        map: data.map,
                        styles: {
                            // 点标记样式
                            marker: new TMap.MarkerStyle({
                                width: 20, // 样式宽
                                height: 30, // 样式高
                                anchor: { x: 10, y: 15 }, // 描点位置
                            }),
                        },
                        geometries: [
                            markerGeo
                        ],
                    });
                }
                let bool = Object.keys(showMoreTitle).map(function(item){return showMoreTitle[item]});
                data.showMoreTitle = bool.every(item => item == true)
                data.loading = false
            } else {
                Notify.warn('数据获取失败')
            }
        })
    })
}

const userCheckHandlePicAndVideoData = (body, key) => {
    const typeKey = key == 'locationPics' ? 'locationPics' : key + 's'
    if (body[typeKey] && body[typeKey].length > 0) {
        body[typeKey].map((item, index) => {
            let obj = {
                index: index + 1,
                src: item.url,
                type: key,
                srcCopy: item.src,
                title: index == 0 ? formDataPicAndVideoTransf.get(key) : '补充照',
                lat: item.lat,
                lng: item.lng,
                angle: item.angle,
                time: item.time,
                text: '',
            }
            data.formData[key].push(obj)
            recivePicPathGetUrl(item.url, index, key)
        })
    }
}

// 用户点击的图片类型
const photoSelectPicType = ({ title: type, current }) => {
    data.userClickPic = type
    data.userClickCurrent = current
}

// 删除图片和图片
const photoDeletePic = ({ title: type, index }) => {
    const value = type
    const arr = data.formData[type].filter(item => (item.type == type && item.src !== ''));
    if (type == 'locationVideo') {
        // 拍视频
        if (arr.length == 5) {
            data.formData[value].splice(index, 1)
            data.formData[value].push({
                index: data.formData[value].length + 1,
                src: '',
                srcCopy: '',
                type: data.userClickPic,
                title: '拍视频',
                lat: '',
                lng: '',
                angle: '',
                time: '',
                text: '',
                poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
            })
            if(value == 'locationVideo'){
                LocationVideo.value.logList(data.formData[value][0].src, 0)
            }
        } else {
            data.formData[value].splice(index, 1)
        }
    } else {
        data.formData[value].splice(index, 1)
        let obj = {
            index: data.formData[value].length + 1,
            src: '',
            srcCopy: '',
            type: data.userClickPic,
            title: '补充照',
            lat: '',
            lng: '',
            angle: '',
            time: '',
            text: '',
        }
        if (arr.length == 10) {
            data.formData[value][0].title = formDataPicAndVideoTransf.get(data.userClickPic)
            data.formData[value].push(obj)
        } else {
            data.formData[value][0].title = formDataPicAndVideoTransf.get(data.userClickPic)
        }
    }

}
// 浏览图片和视频
const photoPreviewImg = ({ type, title: formDataKey, current, url }) => {
    if (type !== '示例') {
        data.formData[formDataKey].map((item, mapIndex) => {
            if (item.type == formDataKey && current == mapIndex) {
                data.previewImageList = [{
                    src: item.src
                }]
                if (type == '视频') {
                    data.sourceVideo = {
                        src: item.src,
                        type: 'video/mp4'
                    }
                }
            }
        })
    }
    if (type == '示例') {
        data.previewImageList = [url]
        data.isViewExample = true
    } else {
        data.isViewExample = false
    }
    if (type == '视频') {
        data.showPreviewVideo = true
    } else {
        data.showPreviewVideo = false
    }
    data.showPreviewImg = true
}
// 获取预览状态
const getShowPreviewImg = val => {
    data.showPreviewImg = val;
};
const getShowPreviewVideo = val => {
    data.showPreviewVideo = val;
};

// 去上报
const FillInEvent = () => {
    if (!validtor()) return
    // 用户是否填写完成
    if (data.userFillInComplete == false) return
    if (data.userCheckDetail) {
        router.go(-1)
    } else {
        if (data.firstSubmitEvent == false) return
        data.firstSubmitEvent = false;
        data.loading = true
        const obj = JSON.parse(JSON.stringify(data.formData))
        let lnglat;
        if(store.state.isH5) {
            if(data.latlng) {
                lnglat = data.latlng;
            } else {
                lnglat = store.state.location;
            }
        } else {
            lnglat = JSON.parse(easyearn.getUserLocation())
        }
        // obj['location'] = obj['locationName']
        obj['locationAddress'] = obj['userSelectDetailLocation']
        // delete obj['locationName']
        delete obj['userSelectTime']
        delete obj['userSelectLocationName']
        delete obj['userSelectDetailLocation']
        const confIdArr = data.addLocationTypeSelect.filter(item => item.select == true)
        obj['reportGroup'] = confIdArr.length > 0 ? confIdArr.map(item => item.value).join('') : ''
        console.log(obj, 'obj');
        Object.keys(obj).map(item => {
            if (item == 'businessTime') {
                let str = ''
                obj[item].map(timeItem => {
                    if (timeItem.start != '请选择' || timeItem.end != '请选择') {
                        str += `${timeItem.start}-${timeItem.end};`
                    }
                })
                obj[item] = str ? str.slice(0, -1) : ''
            }
            if (item == 'businessDate' && obj[item] != null) {
                if(obj[item] != '请选择'){
                    let arr = []
                    data.columns.map(column => {
                        data.businessDateArr.map(item => {
                            if(column.text == item){
                                arr.push(column.value)
                            }
                        })
                    })
                    obj[item] = arr.join(',')
                }else{
                    obj[item] = ''
                }
            }
            if(item == 'businessPhone' && obj[item] != null && obj[item] != '请选择') {
                obj[item] = String(obj[item])
            }
            if(item == 'userLatLng' && obj['userLatLng'] == ''){
                obj['userLatLng'] = `${lnglat.latitude},${lnglat.longitude}`
            }
            if (item == 'businessTimePic' || item == 'locationPics' ||
                item == 'locationVideo' || item == 'businessPhonePic') {
                let arr = []
                let object = {}
                obj[item].map((objItem) => {
                    if (objItem.src == '') {
                        return
                    }
                    let urlo = '';
                    if(objItem.srcCopy) {
                        // resItem.url.indexOf('http') > -1 ? resItem.url : `http://${resItem.url}`
                        urlo = objItem.srcCopy.indexOf('http') > -1 ? objItem.srcCopy : `http://${objItem.srcCopy}`
                    }
                    object = {
                        url: urlo,
                        lat: String(objItem.lat) || "",
                        lng: String(objItem.lng) || "",
                        angle: String(objItem.angle),
                        time: objItem.time || "",
                        text: objItem.text || "",
                        tracks: objItem.tracks || "",
                    }
                    if (object['time']) {
                        object['time'] = Number(object['time']);
                        let year = new Date(object['time']).getFullYear()
                        let month = new Date(object['time']).getMonth() + 1
                        let date = new Date(object['time']).getDate()
                        let hours = new Date(object['time']).getHours()
                        let mins = new Date(object['time']).getMinutes()
                        object['time'] = `${year}-${month}-${date} ${hours}:${mins}:00`
                    }
                    if (item == 'businessTimePic') {
                        object['text'] = obj['businessTime']
                    }
                    if (item == 'businessPhonePic') {
                        object['text'] = String(obj['businessPhone'])
                    }
                    if (item == 'locationVideo' || item == "locationPics") {
                        object['text'] = obj['location']
                    }
                    arr.push(object)
                })
                if (item == 'locationPics') {
                    obj[item] = arr
                } else {
                    obj[item + 's'] = arr
                    delete obj[item]
                }
            }
        })
        console.log(obj);
        const key = `easyearn/info_report/${store.state.userOpenId}/poi/huitu_activity_fe/newLocationIntellgence/${new Date().getTime()}.json`;
        try {

            cosPutObject(data.judge, key, obj, cos).then(async res => {
                let adcodeArr = data.userLocationADCode.split(',')
                let subTypeFromReportGroup = confIdArr.length > 0 ? confIdArr.map(item => item.reportGroup).join(',') : '';
                const reportName = (data.formData.locationName || data.formData.userSelectLocationName).replace(/\s*/g,"");
                const objReport = {
                    pId: data.pageType != 1 ? data.locationPid : '',
                    // id: '',
                    // source_id: '',
                    reportName,
                    reportType: data.pageType - 0 + 3,
                    subType: Number(subTypeFromReportGroup),
                    cosUrl: `http://${res.Location}`,
                    confId: confIdArr.length > 0 ? Number(confIdArr[0].confId) : null,
                    adcode: adcodeArr[adcodeArr.length - 1],
                    sourceFrom: store.state.isH5 ? 2 : 1, // 1 app 2 小程序
                    common: {
                        version: "3.16.0",
                        module_id: "2",
                        vcode: "31600000",
                        loc_x: store.state.location.split(',')[0] || lnglat.latitude,
                        loc_y: store.state.location.split(',')[1] || lnglat.longitude,
                    }
                }
                if(data.pageType != '1' && objReport.pId == "" && store.state){
                    console.log(data.pageType, objReport.pId, 'sssssss');
                    Notify.warn("上报失败");
                    data.loading = false;
                    data.firstSubmitEvent = true;
                    return
                }
                console.log(objReport);
                const infoReportRes = await request("post", api.infoReport, objReport)
                console.log(infoReportRes, 'infoReportRes');
                if (infoReportRes.code == 0) {
                    data.firstSubmitEvent = true;
                    data.columns.map(item => item.select = false)
                    data.isAllowExit = true
                    data.locationDownLine.forEach(item => item.select = false)
                    data.loading = false;
                    router.replace('/report_success')
                } else if (infoReportRes.code !== 0) {
                    console.log(infoReportRes, 'infoReportRes');
                    data.firstSubmitEvent = true;
                    Notify.warn("上报失败，请重试");
                    data.loading = false;
                }
            }).catch(err => {
                console.log(err);
                data.firstSubmitEvent = true;
                Notify.warn("存储失败，请重试");
                data.loading = false;
            })
        } catch {
            data.firstSubmitEvent = true;
            Notify.warn("存储失败，请重试");
            data.loading = false;
        }
    }
}

// 上报验证
const validtor = () => {
    const arr = data.addLocationTypeSelect.every(item => item.select == false)
    if (arr == true && !data.isInternalUser) {
        Notify.text("请选择本次参与类型选择");
        return false
    }
    switch (data.pageType) {
        // 新增
        case '1': {
            let bool = true
            for (const item in data.formData) {
                if (item == 'locationName' && (
                    data.formData[item] == '' || data.formData[item] == undefined
                )) {
                    Notify.text('请补充地点名称')
                    bool = false
                    return
                }
                console.log(data.formData, 'formData');
                if (item == 'userLatLng' && (
                    data.formData[item] == '' || data.formData[item] == undefined
                )) {
                    Notify.text('请补充地点所在位置')
                    bool = false
                    return
                }
                if (item == 'locationVideo') {
                    if (data.formData[item][0].src == '') {
                        Notify.text('请补充现场视频')
                        bool = false
                        return
                    }
                }
                if (item == 'locationPics') {
                    if (data.formData[item][0].src == '') {
                        Notify.text('现场图片门脸照至少上报一张')
                        bool = false
                        return
                    }
                }
                if(item == 'businessTime' && data.formData['businessTime'].length != 0){
                    const start = data.formData['businessTime'][0].start 
                    const end = data.formData['businessTime'][0].end 
                    const businessTimePic = data.formData['businessTimePic']
                    if(start != '请选择' && end != '请选择' && businessTimePic[0].src == ''){
                        Notify.text('请拍摄营业时间照')
                        bool = false
                        return
                    }
                    data.formData['businessTime'].map(time => {
                        if(time.start == '请选择' && time.end == '请选择'){
                            Notify.text('请将营业时间补充完整')
                            bool = false
                            return
                        }
                        if((time.start != '' && time.start != '请选择' && time.end == '请选择') ||
                        (time.start == '请选择' && time.end != '' && time.end != '请选择')){
                            Notify.text('请将营业时间补充完整')
                            bool = false
                            return
                        }
                    })
                }
                if(item == 'businessDate'){
                    const businessTimePic = data.formData['businessTimePic']
                    if(data.formData['businessDate'] != '请选择' && businessTimePic[0].src == ''){
                        Notify.text('请拍摄营业时间照')
                        bool = false;
                        return
                    }
                }
                if(item == "businessPhone"){
                    const businessPhonePic = data.formData['businessPhonePic']
                    if(data.formData['businessPhone'] != '' && businessPhonePic[0].src == ''){
                        Notify.text('请拍摄营业电话照')
                        bool = false;
                        return
                    }
                    if(data.formData['businessPhone'] != ''){
                        let datas = ''
                        if(data.formData['businessPhone'].includes(',') || data.formData['businessPhone'].includes('，')){
                            datas = data.formData['businessPhone'].includes(',') ? 
                                data.formData['businessPhone'].split(',') : data.formData['businessPhone'].split('，')
                        }else{
                            datas = [data.formData['businessPhone']]
                        }
                        for (const dataItem in datas) {
                            let reg = /^((([(]?\d{3,4}[-)]?)?\d{7,8})|(1[3567894]\d{9}))$/
                            if (!reg.test(String(datas[dataItem]))) {
                                Notify.text('请填写正确的手机号码')
                                bool = false
                                return
                            }
                        }
                    }
                }
            }
            return bool
        }

        // break;
        // 过期
        case '2': {
            let bool = true
            for (const item in data.formData) {
                if (item == 'locationPassReason') {
                    if (data.formData[item] == '' || data.formData[item] == undefined) {
                        Notify.text('请选择地点下线原因')
                        bool = false
                        return
                    }
                }
                if (item == 'locationName') {
                    if (data.formData[item] == '' || data.formData[item] == undefined) {
                        Notify.text('请填写地点名称')
                        bool = false
                        return
                    }
                }
                if (item == 'locationVideo') {
                    if (data.formData[item][0].src == '') {
                        Notify.text('请补充现场视频')
                        bool = false
                        return
                    }
                }
                if (item == 'locationPics') {
                    if (data.formData[item][0].src == '') {
                        Notify.text('现场图片门脸照至少上报一张')
                        bool = false
                        return
                    }
                }
            }
            return bool
        }

        // break;
        // 该要素
        case '3': {
            let bool = true
            for (const item in data.formData) {
                if (item == 'locationName') {
                    if (data.formData[item] == '' || data.formData[item] == undefined) {
                        Notify.text('请填写地点名称')
                        bool = false
                        return
                    }
                }
                if (item == 'locationVideo') {
                    if (data.formData[item][0].src == '') {
                        Notify.text('请补充现场视频')
                        bool = false
                        return
                    }
                }
                if (item == 'locationPics') {
                    if (data.formData[item][0].src == '') {
                        Notify.text('现场图片门脸照至少上报一张')
                        bool = false
                        return
                    }
                }
                if(item == 'businessDate'){
                    const businessTimePic = data.formData['businessTimePic']
                    if(data.formData['businessDate'] != '请选择' && businessTimePic[0].src == ''){
                        Notify.text('请拍摄营业时间照')
                        bool = false;
                        return
                    }
                }
                if(item == "businessPhone"){
                    const businessPhonePic = data.formData['businessPhonePic']
                    if(data.formData['businessPhone'] != '' && businessPhonePic[0].src == ''){
                        Notify.text('请拍摄营业电话照')
                        bool = false;
                        return
                    }
                    if(data.formData['businessPhone'] != ''){
                        let datas = ''
                        if(data.formData['businessPhone'].includes(',') || data.formData['businessPhone'].includes('，')){
                            datas = data.formData['businessPhone'].includes(',') ? 
                                data.formData['businessPhone'].split(',') : data.formData['businessPhone'].split('，')
                        }else{
                            datas = [data.formData['businessPhone']]
                        }
                        for (const dataItem in datas) {
                            let reg = /^((([(]?\d{3,4}[-)]?)?\d{7,8})|(1[3567894]\d{9}))$/
                            if (!reg.test(String(datas[dataItem]))) {
                                Notify.text('请填写正确的手机号码')
                                bool = false
                                return
                            }
                        }
                    }
                }
                if(item == 'businessTime' && data.formData['businessTime'].length != 0){
                    const start = data.formData['businessTime'][0].start 
                    const end = data.formData['businessTime'][0].end 
                    const businessTimePic = data.formData['businessTimePic']
                    if(start != '请选择' && end != '请选择' && businessTimePic[0].src == ''){
                        Notify.text('请拍摄营业时间照')
                        bool = false
                        return
                    }
                    data.formData['businessTime'].map(time => {
                        if(time.start == '请选择' && time.end == '请选择'){
                            Notify.text('请将营业时间补充完整')
                            bool = false
                            return
                        }
                        if((time.start != '' && time.start != '请选择' && time.end == '请选择') ||
                        (time.start == '请选择' && time.end != '' && time.end != '请选择')){
                            Notify.text('请将营业时间补充完整')
                            bool = false
                            return
                        }
                    })
                }
            }
            return bool
        }
        // break;

        default:
            break;
    }
    return true
}
// 展示营业日期弹框
const showBusinessDatePopup = () => {
    if (data.userCheckDetail) return
    selectBusinessDatePopup.value = true
}

// 营业日期选择
const businessDateConfirm = () => {
    const dates = JSON.parse(JSON.stringify(data.businessDateArr))
    dates.sort(function(a, b) {  
        let map = {  
            "周一": 1,  
            "周二": 2,  
            "周三": 3,  
            "周四": 4,  
            "周五": 5,  
            "周六": 6,  
            "周日": 7
        };  
        return map[a] - map[b];
    });
    if(data.businessDateArr.length == 7){
        data.formData['businessDate'] = '周一至周日'
    }else{
        data.formData['businessDate'] = dates.join('， ')
    }
    selectBusinessDatePopup.value = false
    if(data.businessDateArr.length == 0){
        data.formData['businessDate'] = '请选择'
        if(data.formData.businessTime.length == 0){
            data.formData.businessTimePic = [
                {
                    index: 1,
                    type: 'businessTimePic',
                    src: '',
                    srcCopy: '',
                    title: '营业时间照',
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                }
            ]
        }
        // resetBusinessPhone('businessTimePic')
        // return
    }
}

const businessDateCancel = () => {
    selectBusinessDatePopup.value = false
}
// 类型选择
const locationTypeSelect = (value) => {
    console.log(data.pageType, 'pageType');
    if (data.userCheckDetail) return
    data.addLocationTypeSelect.map(item => {
        item.value == value ? item.select = true : item.select = false
    })
    // 判断是否在地点新增类型中点击了服务区
    if (data.pageType == 1) data.showAddTemplateText = value.includes(',271211')
    data.locationTypeSelectClick = true
}

// 选择营业时间
const businessTimeconfirm = (value) => {
    const {
        businessTime
    } = data.formData
    const {
        type,
        index
    } = useSelectTimeType.value
    businessTime[index][type] = value
    businessTimeCancel()
}
const businessTimeCancel = () => {
    useSelectTimePopup.value = false
}
// 删除营业时间
const deleBusiness = (index, type) => {
    const {
        businessTime,
        // businessPhone
    } = data.formData
    if (type == 'time') {
        businessTime.splice(index, 1)
    }
    if(data.formData.businessTime.length == 0 && data.formData.businessDate == '请选择'){
        data.formData.businessTimePic = [
            {
                index: 1,
                type: 'businessTimePic',
                src: '',
                srcCopy: '',
                title: '营业时间照',
                lat: '',
                lng: '',
                angle: '',
                time: '',
                text: '',
            }
        ]
    }
    // else if(type == 'phone'){
    //     businessPhone.splice(index, 1)
    // }
}

// 添加营业时间
const addFormDataBusiness = (type) => {
    const {
        businessTime,
        // businessPhone
    } = data.formData
    if (businessTime.length == 3) {
        Notify.text('已达营业时间添加上限~')
        return
    }
    if (type == 'time') {
        businessTime.push({
            start: '请选择',
            end: '请选择'
        })
    }
    // else if(type == 'phone'){
    //     businessPhone.push({
    //         date: null
    //     })
    // }
}
const dialogOk = () => {
    if(data.locshow) {
        return;
    }
    if(store.state.fullPath != 'no') {
        localStorage.removeItem('data');
    }
    data.isAllowExit = true
    store.dispatch("setMessageAppearDetailVisble", false);
    if(data.pageType == '3' && data.map){
        data.map.destroy()
    }
    resetFromData()
    router.go(-1);
};
const dialogCancle = () => {
    store.dispatch("setMessageAppearDetailVisble", false);
};
// 展示弹框
const showSelectTimePopup = (type, index) => {
    if (data.userCheckDetail) return
    useSelectTimePopup.value = true
    useSelectTimeType.value = {
        type,
        index
    }
}

// 用户戳点
const PicLoction = () => {
    if(!data.userCheckDetail && data.formData.locationName == '') {
        Toast.text('请先进行地点名称的选择～', {
            duration: 1000
        })
        return
    }
    console.log(data.formData.userLatLng, '获取的值');
    if(data.isH5){
        if(data.datayime) {
          goweixin();
        //   goweixin('name')
          data.datayime = false;
          setTimeout(() => {data.datayime = true } ,3000)
        }
        // goweixin()
        
    }else{
        const version = Number(easyearn.getVersionCode());
        if (version * 1 > 32699999) {

            easyearn.poiReportLocation(
                data.formData.userLatLng.split(',')[1],
                data.formData.userLatLng.split(',')[0],
                data.userCheckDetail,
                true,
                '100'
    
            );
        } else {
            easyearn.poiReportLocation(
                data.formData.userLatLng.split(',')[1],
                data.formData.userLatLng.split(',')[0],
                data.userCheckDetail,
                false
            );

        }
    }
}
const setCheckContentAndResult = (innerCheckResult, checkResult) => {
    // 判断是否展示不合格原因 0 不合格 1 合格
    const businessTime = judegCheckContentResult(innerCheckResult, 'businessTime', checkResult)
    const businessPhone = judegCheckContentResult(innerCheckResult, 'businessPhone', checkResult)
    const businessDate = judegCheckContentResult(innerCheckResult, 'businessDate', checkResult)
    const locationName = judegCheckContentResult(innerCheckResult, 'locationName', checkResult)
    const coordinate = judegCheckContentResult(innerCheckResult, 'coordinate', checkResult)
    data.checkContent = {
        businessTime:  businessTime.show,
        businessPhone: businessPhone.show,
        businessDate:  businessDate.show,
        locationName:  locationName.show,
        coordinate:  coordinate.show,
    }
    // 判断展示的不合格原因
    data.checkContentResult = {
        businessTime:  businessTime.reason,
        businessPhone: businessPhone.reason,
        businessDate:  businessDate.reason,
        locationName:  locationName.reason,
        coordinate:  coordinate.reason,
    }
    // 如果所有都是true，就不展示不合格原因
    if(Object.keys(data.checkContent).every(item => data.checkContent[item] == true)){
        data.isAuditNoPass = false
    }
}
// 判断要素是否合格 和 不合格原因
/**
 * 0不合格 1合格
 * @param {*} a 银河
 * @param {*} key 
 * @param {*} b 筑巢
 */
const judegCheckContentResult = (a, key, b) => {
    // false 展示 true 不展示
    if(a[key] == undefined || a[key] == '-1'){
        return {
            show: true,
            reason: ''
        }
    }
    if(a[key] == '0'){
        // 使用银河审核评论
        return {
            show: false,
            reason: '线上存在正确的数据'
        }
    }else if(a[key] == '1' && b[key] == '0'){
        // 使用筑巢评论
        return {
            show: false,
            reason: b[key + 'Reason']
        }
    }else if(a[key] == '1' && b[key] == '1'){
        return {
            show: true,
            reason: ''
        }
    }else{
        return {
            show: true,
            reason: ''
        }
    }
}
// 位置选好后Android 端通知回调JS端
window.onLocationPicked = (lng, lat) => {
    console.log("调用成功", lat, lng);
    data.formData.userLatLng = `${lat},${lng}`;
    if (data.isH5) {
        location = store.state.location;
        console.log(location);
    }
    data.photoLatLng = `${lat},${lng}`
    data.userSelectPoint = true;
    // 通过逆地址解析得到pid
    getUserLocationInfo({ lng, lat, type: 'add' })
};

// 返回上报类型选择
const backEvent = () => {
    // if(data.userCheckDetail){
    router.go(-1)
    // }else{

    // }
    // router.push('/add_location_type')
}
// 格式化数据
const resetFromData = () => {
    data.locationDownLine.map(item => item.select = false)
    data.columns.map(item => item.select = false)
    data.userSelectPoint = false
    data.userFillInComplete = false
    data.locationTypeSelectClick = false
    data.firstSubmitEvent = true
    data.addLocationTypeSelect.forEach(item => item.select = false)
    data.locationDownLine.forEach(item => item.select = false)
    data.isShowFillInBtn = true;
    if (!data.userCheckDetail) {
        data.formData = {
            locationName: '', // 名称
            locationNewName: '', // 新的店名
            userLatLng: '', // 用户戳点坐标
            userSelectTime: new Date(), // 从date-picker组件中获取的时间
            businessDate: '请选择', // 营业日期
            // 展示在页面上的营业时间
            businessTime: [
                {
                    start: '请选择',
                    end: '请选择'
                }
            ],
            // 营业图片
            businessTimePic: [
                {
                    index: 1,
                    src: '',
                    type: 'businessTimePic',
                    srcCopy: '',
                    title: '营业时间照',
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                }
            ],
            // 现场图片
            locationPics: [
                {
                    index: 1,
                    src: '',
                    type: 'locationPics',
                    srcCopy: '',
                    title: "门脸照",
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                }
            ],
            // 现场视频
            locationVideo: [
                {
                    index: 1,
                    src: '',
                    type: 'locationVideo',
                    srcCopy: '',
                    title: '拍视频',
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                    poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
                }
            ],
            // 营业电话图片
            businessPhonePic: [
                {
                    index: 1,
                    src: '',
                    type: 'businessPhonePic',
                    srcCopy: '',
                    title: '营业电话照',
                    lat: '',
                    lng: '',
                    angle: '',
                    time: '',
                    text: '',
                }
            ],
            // 营业电话
            businessPhone: '',
            userComment: null, // 用户补充
            locationPassReason: null, // 地点过期原因
            userSelectLocationName: '', // 用户戳点中文位置
            userSelectDetailLocation: '', // 用户戳点后输入详细地址
        }
    } else {
        data.formData = {
            locationName: '', // 名称
            locationNewName: '', // 新的店名
            userLatLng: '', // 用户戳点坐标
            userSelectTime: new Date(), // 从date-picker组件中获取的时间
            businessDate: '', // 营业日期
            // 展示在页面上的营业时间
            businessTime: [
                {
                    start: '',
                    end: ''
                }
            ],
            // 营业图片
            businessTimePic: [],
            // 现场图片
            locationPics: [],
            // 现场视频
            locationVideo: [],
            // 营业电话图片
            businessPhonePic: [],
            // 营业电话
            businessPhone: '',
            userComment: '', // 用户补充
            locationPassReason: '', // 地点过期原因
            userSelectLocationName: '', // 用户戳点中文位置
            userSelectDetailLocation: '', // 用户戳点后输入详细地址
        }
    }
}
// 点击添加模板
const addTemplateEvent = (type) => {
    const templateMap = ['油号：汽油xx号、xx号、xx号，柴油xx号;加油枪数：xx个', '充电枪数：xx个; 方向：xx度，xx度(可选);  快充个数：xx个']
    data.formData.userComment = templateMap[type];
}
const goweixin = (va) =>    {
    // data.scrollTop = document.getElementsByClassName('allstyle')[0].scrollTop;
      // document.getElementsByClassName('allstyle')[0].scrollTo(0, document.getElementsByClassName('allstyle')[0].scrollTop + 100);
    //   data.businessTimeAdd = '';
    localStorage.removeItem('data')
        let agindata = {};
      data.map = '';
      data.marker = '';
      Object.keys(data).forEach(item => {
        agindata[item] = JSON.parse(JSON.stringify(data[item]))
      })
    localStorage.setItem('data', JSON.stringify(data))
    // return;
    let fullPath = route.fullPath;
    if (va == 'photo') {
        wx.miniProgram.navigateTo({url: `/pages/h5web/h5web?uu=latyu&name=${data.formData.locationName}&reportType=${data.pageType - 0 + 3}&from=h5HuiTu&urlcoe=${fullPath}`});
        return;
    }
    if (va == 'name') {
        wx.miniProgram.navigateTo({url: `/pages/H5PoiReportSearch/H5PoiReportSearch?name=${data.formData.locationName}&reportType=${data.pageType - 0 + 3}&from=h5HuiTu&url=${fullPath}`});
        return;
    }
    wx.miniProgram.navigateTo({url: `/pages/H5PicLocation/H5PicLocation?userCheckDetail=${data.userCheckDetail}&latitude=${data.formData.userLatLng.split(',')[0]}&longitude=${data.formData.userLatLng.split(',')[1]}&reportType=${data.pageType - 0 + 3}&from=h5HuiTu&url=${fullPath}`}) 
}
</script>
<style lang='scss' scoped>
  .wrapper_overlay {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: white;
    .content {
        display: flex;
        width: 85%;
        height: 60px;
        background: #fff;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        color: red;
        font-size: 14px;
    }
  }
#allstyle {
    font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 20px !important;
        // padding: 10px 10px 0px !important;
        color:black !important;
        background: #fff;
        font-family: 'SimHei';
}
.goOnInfo3 {
    // width: 96%;
    // margin-top: 13px;
    // height: 100px;
    // margin-bottom: 150px;
    // opacity: 0.6;
    // background: #f0f1f5;
    // border-radius: 4px;
    // outline: none;
    // border: none;
    // font-weight: 400;
    // font-size: 14px;
    // line-height: 20px;
    // padding: 10px 10px 0px;
        // width: 96%;
        // height: 100px;
        // margin-bottom: 150px;
        // //opacity: 0.6;
        // background: #F6F6F9;
        // border-radius: 4px;
        // outline: none;
        // border: none;
        // background-color: #000;
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 20px !important;
        // padding: 10px 10px 0px !important;
        color:black !important;
    }
.wayInfo_input {
       width: 92%;
       border: none;
       height: 52px;
    }
button,
input {
  outline: none;
  caret-color: #0077ff;
}
.mgTp5 {
    margin-top: 5PX;
}

.mgBm5 {
    margin-bottom: 5PX;
}

.mgLf10 {
    margin-left: 10PX;
}
.mgTp6 {
    margin-top: 6PX;
}
.mgTp10 {
    margin-top: 10PX;
}
.mgTp12 {
    margin-top: 12PX;
}
.pdTp14 {
    padding-top: 14PX;
}
.mgTp16 {
    margin-top: 16PX;
}
.mgTp20 {
    margin-top: 20PX;
}
.MGTP28{
    margin-top: 28Px;
}
.MGTP24{
    margin-top: 24Px;
}
.mgBm10 {
    margin-bottom: 10PX;
}

.fontWNor {
    font-weight: normal !important;
}

.borderBM1{
    border-bottom: 0.5px solid rgba($color: #000, $alpha: 0.1);
}
.borderNone {
    border: none;
}

.locationGet {
    font-size: 14px;
    height: 52px;
    line-height: 52px;
}

.locationGetHui {
    color: #c8c9cc;
}

.inputSet {
    border: none;
    width: 100%;
    padding-left: 15px;
    font-size: 13px;
}
.divReplaceInputShowData{
    // padding-left: 15px;
    font-size: 13px;
}
.spanReplaceInputShowData{
    display: inline-block;
    text-align: center;
    flex: 1;
    height: 52px;
    line-height: 52px;
    color: #17181a;
}
.inputSet:focus {
    outline: none;
}

.inputNormal {
    border: 1px solid rgba($color: #17181a, $alpha: 0.15);
    font-size: 13px;
    flex: 1;
}

.locationNewName {
    display: flex;
}

.advise_photo_info {
    font-size: 14px;
    color: #17181a;
    opacity: 0.7;
    padding: 6Px 0 13Px;
    font-weight: 500;
}
.advise_photo_info_business{
    height: 40px;
    line-height: 20px;
}
.wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 2001;
}

.detail_title {
    font-size: 16px;
    font-weight: bold;
    opacity: 0.9;
    // opacity: 1;
    // font-family: NotoSansCJKsc-Bold;
    font-family:Arial, Helvetica, sans-serif;
}

.date_picker_select_time {
    display: inline-block;
    height: 52Px;
    line-height: 52Px;
    width: 30%;
    text-align: left;
    font-size: 14px;
    vertical-align: middle;
    color: #c8c9cc;
}
.new_date_picker_select_time{
    width: 16%;
}
.date_picker_select_time_over{
    color: #17181a;
}
.date_picker_select_time_mark{
    margin:0 5%;
    font-size: 14px;
    color: #5c5d5e;
    vertical-align: middle;
}
.businessTime_title{
    display: block;
    font-weight: 500;
    font-size: 14px;
    opacity: 0.7;
    margin-top: 8px;
}
.in_block_span{
    line-height: 20Px;
    height: 20Px;
    color: #000;
    opacity: 0.7;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4Px;
    .business_icon{
        width: 17Px;
        height: 17Px;
        margin-right: 9.5Px;
        display: inline-block;
        vertical-align: middle;
    }
    .business_span{
        height: 20Px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20Px;
        color: #0088ff;
        display: inline-block;
        vertical-align: middle;
        margin-top: 1px;
    }
    .business_picker{
        font-weight: 400;
        color: #000;
    }
}
.business_MB_TP_20{
    display: block;
    margin-top: 20Px;
}
.business_time_picker{
    margin-right: 15%;
}
@media all and (max-width: 371px) {
    .business_time_picker{
        margin-right: 10%;
    }
}
@media all and (max-width: 320px) {
    .business_time_picker{
        margin-right: 5%;
    }
}
.typeSelectBox {
    .typeSelect {
        // display: flex;
        // justify-content: space-around;
        width: 100%;
        .locationType {
            display: inline-block;
            width: 46%;
            font-size: 13px;
            margin: 5px 5px;
        }
    }

    .typeSelectBtnClick {
        background-color: #ccc !important;
    }
}

.locationDownLineDiv {
    width: 100%;
    margin-top: 10px;
    padding-bottom: 10px;
}

.locationDownLineSpan {
    border: 1px solid rgba($color: #17181a, $alpha: 0.15);
    padding: 5PX 30PX;
    font-size: 16px;
}
.auditNoPass_more{
    font-weight: 500;
    font-size: 14px;
    color: #ff4433;
    margin-left: 7%;
}
.auditNoPass_ab{
    position: absolute;
    white-space: nowrap;
}
@media all and (max-width: 307px) {
    .auditNoPass_more{
        margin-left: 2%;
    }
}
.auditNoPass {
    margin-right: 0;
    margin-top: -10px;
    height: 44px;
    background: #fff7de;
    display: flex;
    align-items: center;
    img {
        width: 16px;
        height: 18px;
        margin-left: 20px;
        margin-right: 4px;
        margin-top: -2px;
    }
    div {
        span{
            font-size: 14px;
            color: #f98017;
            font-weight: 500;
        }
        // span:nth-child(1){
        //     margin-right: 2px;
        // }
        span:nth-child(2){
            // margin-left: 2px;
            color: #ff4433;
        }
    }
}
.locationDownLineSpanActive {
    width: 100%;
    height: 38px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    line-height: 38px;
    &.locationDownLine{
        width: 46%;
        display: inline-block;
        margin: 5px 5px;
    }
    &.defaultBtn {
        color: #000000;
        border: 1px solid rgba($color: #17181a, $alpha: 0.15);
        background: rgba($color: #fff, $alpha: 0.15);
    }
    &.activeBtn {
        background: #e5f3ff;
        border: 1px solid #0088ff;
        color: #0088ff;
    }
}
.redPoint{
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #ff4433;
    vertical-align: top;
    position: relative;
    top: 3px;
}
.businessPhone{
    input{
        width: 100%;
        text-align: left;
    }
    .businessPhone_span_box{
        display: flex;
        align-items: center;
        input{
            display: inline-block;
            height: 52Px;
            line-height: 52Px;
            width: 30%;
            text-align: left;
            font-size: 14px;
            vertical-align: middle;
            flex: 1;
            color: #17181a;
        }
        input::-webkit-input-placeholder{ /*WebKit browsers*/
            color: #c8c9cc;
        }
        input::-moz-input-placeholder{ /*Mozilla Firefox*/
            color: #c8c9cc;
        }
        input::-ms-input-placeholder{ /*Internet Explorer*/ 
            color: #c8c9cc;
        }
    }
}
.box {
    .del_add_btn {
        display: inline-block;
        width: 10%;
        text-align: center;
        vertical-align: middle;
    }

    .businessDate {
        .businessDate_span_box{
            display: flex;
            align-items: center;
        }
        .select {
            flex: 1;
        }
    }
}

.wrapper {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;

    .content {
        display: flex;
        width: 85%;
        height: 60px;
        background: #fff;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        color: red;
        font-size: 14px;
    }
}

.goOnInfo {
    width: 96%;
    margin-top: 13px;
    height: 110px;
    margin-bottom: 150px;
    // opacity: 0.6;
    // background: #f0f1f5;
    background-color: rgba($color: #f0f1f5, $alpha: 0.6);
    border-radius: 4px;
    outline: none;
    border: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 10px 0px;
}

.add_template{
    padding: 0;
    margin-bottom: 200px;
    padding-bottom: 80px;
    .add_template_text {
        margin-top: 10px;
        margin-left: 10px;
        color: #2FB3F2;
        div{
            height: 30px;
            line-height: 30px;
        }
    }
    .textarea_info{
        width: 100%;
        height: 100%;
        border: none;
        background-color: transparent;
        padding: 10px 10px 0px;
        box-sizing: border-box;
    }
}

textarea:focus-visible{
    outline: none;
}

.textarea_public {
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    padding: 0;
}

.mapInfoUl {
    padding-left: 5px;
}

.mapInfoLi {
    font-size: 11px;
}
.showFillinBtn{
    // overflow: visible;
    display: block;
}
.hiddenFillinBtn{
    // overflow: hidden;
    display: none;
}
.mapBanner {
    width: 100%;

    img {
        width: 100%;
        display: block;
    }
}
.map_location{
    text-align: center;
    font-weight: 500;
    color: #17181a;
    opacity: 0.5;
    margin-top: 8Px;
    font-size: 13px;
}


// .sheet_pick_date {
//     text-align: center;

//     .cloums_week {
//         padding:0 15Px;
//     }

//     .active {
//         color: rgba($color: #0791e8, $alpha: 0.5);
//     }

//     .btn {
//         margin-top: 15px;
//         margin-bottom: 50px;
//     }

//     .btn_public {
//         font-size: 16px;
//         display: inline-block;
//         width: 50%;
//         text-align: center;
//     }

//     & :deep(.nut-checkbox) {
//         display: flex;
//         margin-right: 20px;
//         justify-content: center;
//     }
//     & :deep(.nut-checkbox__label) {
//         margin-left: 10px;
//         flex: none !important;
//     }

// }

.dialogObscuration {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;

    .dialogImg {
        background: url("../../assets/image_message_appear/messageAppearDetail.png");
        background-size: 320px 171px;
        width: 320px;
        height: 171px;
        position: fixed;
        top: 50%;
        margin-top: -85px;
        left: 50%;
        margin-left: -160px;

        span {
            display: inline-block;
            position: absolute;
            width: 92px;
            height: 42px;
            bottom: 20px;
            border-radius: 21px;
        }

        span:nth-of-type(1) {
            right: 112px;
        }

        span:nth-of-type(2) {
            right: 20px;
        }
    }
}
.popup-demo {
    padding: 0 16px;
}
.businessData_popup_header {
    display: flex;
    align-items: center;
    height: 63px;
}
.businessData_popup_cloums_week{
    padding-bottom: 90px;
}
.businessData_popup_title {
    flex: 1;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: var(--td-text-color-primary, rgba(0, 0, 0, 0.9));
}
.businessData_popup_btn {
    font-size: 14px;
    padding: 16px;
}
.businessData_popup_btn--cancel {
    color: var(--td-text-color-secondary, rgba(0, 0, 0, 0.6));
}
.businessData_popup_btn--confirm {
    color: #0052d9;
}
/* 横向布局 */
.horizontal-box {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 50px 50px;
    align-items: center;
    .card{
        position: relative;
        display: inline-block;
        border: 1px solid rgba($color: #17181a, $alpha: 0.15);
        border-radius: 4px;
        // padding: 12px 22px;
        padding: 8%;
        font-weight: 500;
        text-align: center;
        font-size: 14px;
        margin: 5px;
        .t-checkbox{
            padding: 0;
        }
    }
    .card--active {
        border-color: #0052d9;
    }
    .card--active::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        border: 14px solid #0052d9;
        border-bottom-color: transparent;
        border-right-color: transparent;
    }
    .card__icon {
        color: #fff;
        position: absolute;
        left: 1.5px;
        top: 1.5px;
        z-index: 1;
    }
}
.remark{
    color: #000;
    // opacity: 0.7;
    background-color: rgba($color: #fff, $alpha: 0.7);
    font-weight: 700;
    font-size: 16px;
    margin-top: 24Px;
}
// 修改时间位置信息
.newcss {
    font-family:Arial, Helvetica, sans-serif;

    & :deep(.t-picker__title) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__cancel) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__confirm) {
        font-size: 15px !important;
    }
    & :deep(.t-picker-item){
        margin-top: 20Px;
        font-family:Arial, Helvetica, sans-serif;
        font-size: 15px;
        height:  var(--td-picker-item-height, 45px);
    }
    // & :deep(.t-picker__indicator){
    //     margin-top: 13px;
    //     // font-family:Arial, Helvetica, sans-serif;
    //     // font-size: 15px;
    //     // line-height: var(--td-picker-item-height, 45px);
    //     // height:  var(--td-picker-item-height, 45px);;
    // }
    & :deep(.t-picker__indicator) {
        top: 2rem;
        height:  var(--td-picker-item-height, 45px);;
    }
    .t-picker__main {
        .t-picker-item__group{
            .t-picker-item{
                // margin-top: 35Px !important;
            }
        }
    }
}
.newcss5 {
    font-family:Arial, Helvetica, sans-serif;

    & :deep(.t-picker__title) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__cancel) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__confirm) {
        font-size: 15px !important;
    }
    & :deep(.t-picker-item){
        margin-top: 6Px;
        font-family:Arial, Helvetica, sans-serif;
        font-size: 15px;
        height:  var(--td-picker-item-height, 45px);
    }
    // & :deep(.t-picker__indicator){
    //     margin-top: 13px;
    //     // font-family:Arial, Helvetica, sans-serif;
    //     // font-size: 15px;
    //     // line-height: var(--td-picker-item-height, 45px);
    //     // height:  var(--td-picker-item-height, 45px);;
    // }
    & :deep(.t-picker__indicator) {
        top: 2rem;
        height:  var(--td-picker-item-height, 45px);;
    }
    .t-picker__main {
        .t-picker-item__group{
            .t-picker-item{
                // margin-top: 35Px !important;
            }
        }
    }
}
.t_date_time_picker_self{
    & :deep(.t-picker__indicator) {
        top: 2rem;
    }
}
.appeared {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 19px 0;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.05);
    z-index: 1000;
    & button {
        width: 90%;
        padding: 13px 0;
        border: none;
        background-color: #e5f3ff;
        border-radius: 38px;
        font-weight: Bold;
        font-size: 16px;
        color: #fff;
        text-align: center;
        line-height: 16px;
        -webkit-tap-highlight-color: rgb(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;
        outline: none;
    }

    .complete {
        background-color: #0088ff;
    }
}
.business_del_box{
    .business_del_info{
        height: 24px;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 30px;
    }
    .business_info_btn{
        text-align: right;
    }
    .cancel{
        display: inline-block;
        font-weight: 700;
        font-size: 16px;
        color: #0088ff;
        padding: 12px 30px 14px;
        background-color: #fff;
        height: 16px;
        line-height: 16px;
    }
    .confirm{
        display: inline-block;
        font-weight: 700;
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        color: #fff;
        padding: 12px 30px 14px;
        background-color: #0088ff;
        border-radius: 21px;
    }
}
</style>